import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  b as getKClass,
  p5 as classMeta,
  a1 as Unit_getInstance,
  e1 as ArrayList,
  k9 as IllegalStateException,
  r6 as toString,
  ba as printStackTrace,
  f5 as println,
  f7 as Regex,
  b3 as listOf,
  s3 as plus,
  j4 as toSet,
  c4 as toList,
  j1 as LinkedHashMap,
  a2 as collectionSizeOrDefault,
  f as _Char___init__impl__6a9atx,
  p7 as indexOf,
  f2 as copyToArray,
  z5 as interfaceMeta,
  y2 as last,
  h2 as emptyList,
  y9 as ensureNotNull,
  m3 as mutableListOf,
  z3 as setOf,
  c3 as listOf_0,
  t9 as THROW_ISE,
  g9 as Enum,
  q7 as isBlank,
  x5 as getStringHashCode,
  s9 as THROW_CCE,
  y5 as hashCode,
  s5 as equals,
  da as throwUninitializedPropertyAccessException,
  ea as toString_0,
  g8 as substringAfter,
  b8 as startsWith,
} from './kotlin-kotlin-stdlib.mjs';
import {
  a4 as values,
  w5 as values_0,
  z5 as values_1,
  m6 as values_2,
  u6 as values_3,
  t7 as values_4,
  c5 as values_5,
  i5 as values_6,
  x3 as AglAutomatonDslMarker,
  z3 as Automaton,
  y3 as AutomatonBuilder,
  b4 as ParseAction,
  c4 as TransitionBuilder,
  w3 as Scope,
  m3 as AsmElementPath,
  n3 as AsmElementProperty,
  o3 as AsmElementReference,
  q3 as AsmElementSimple,
  u3 as AsmSimple,
  t3 as AsmSimpleTreeWalker,
  p3 as AsmElementSimpleBuilder,
  s3 as AsmSimpleBuilder,
  r3 as AsmSimpleBuilderMarker,
  v3 as ListAsmElementSimpleBuilder,
  q5 as InputLocation,
  s5 as ParseTreeException,
  t5 as ParserConstructionFailedException,
  r5 as ParseFailedException,
  u5 as ParserException,
  v5 as ParserTerminatedException,
  y5 as AutomatonKind,
  x5 as AutomatonKind_api,
  b6 as CompletionItem,
  a6 as CompletionItemKind,
  f6 as CompletionProvider,
  i6 as Formatter,
  j6 as GrammarRegistry,
  l6 as LanguageDefinition,
  x6 as LanguageRegistry,
  w6 as LanguageProcessor,
  t6 as LanguageProcessorException,
  l7 as SentenceContext,
  o6 as LanguageIssue,
  n6 as LanguageIssueKind,
  v6 as LanguageProcessorPhase,
  e6 as CompletionProviderOptions,
  s6 as LanguageProcessorConfiguration,
  a7 as ParseOptions,
  f7 as ProcessOptions,
  j7 as SemanticAnalysisOptions,
  o7 as SyntaxAnalysisOptions,
  c6 as CompletionProviderOptionsBuilder,
  d6 as CompletionProviderOptionsDefault,
  p6 as LanguageProcessorConfigurationBuilder,
  q6 as LanguageProcessorConfigurationDefault,
  r6 as LanguageProcessorConfigurationDslMarker,
  y6 as ParseOptionsBuilder,
  z6 as ParseOptionsDefault,
  c7 as ProcessOptionsBuilder,
  d7 as ProcessOptionsDefault,
  e7 as ProcessOptionsDslMarker,
  h7 as SemanticAnalysisOptionsBuilder,
  i7 as SemanticAnalysisOptionsDefault,
  m7 as SyntaxAnalysisOptionsBuilder,
  n7 as SyntaxAnalysisOptionsDefault,
  g6 as ExpectedAtResult,
  h6 as FormatResult,
  k6 as IssueCollection,
  b7 as ParseResult,
  g7 as ProcessResult,
  k7 as SemanticAnalysisResult,
  p7 as SyntaxAnalysisResult,
  w7 as AglStyle,
  r7 as AglStyleModel,
  s7 as AglStyleRule,
  v7 as AglStyleSelector,
  u7 as AglStyleSelectorKind,
  u4 as Grammar,
  m4 as GrammarItem,
  o4 as GrammarOption,
  p4 as GrammarReference,
  l4 as GrammarExeception,
  n4 as GrammarLoader,
  q4 as GrammarRegistry_0,
  t4 as GrammarRule,
  a5 as NormalRule,
  d5 as OverrideKind,
  e5 as OverrideRule,
  f5 as PreferenceOption,
  g5 as PreferenceRule,
  r4 as GrammarRuleItemNotFoundException,
  s4 as GrammarRuleNotFoundException,
  x4 as Namespace,
  y4 as NodeType,
  g4 as Choice,
  d4 as ChoiceAmbiguous,
  e4 as ChoiceLongest,
  f4 as ChoicePriority,
  i4 as Concatenation,
  h4 as ConcatenationItem,
  j4 as Embedded,
  k4 as EmptyRule,
  v4 as Group,
  w4 as ListOfItems,
  z4 as NonTerminal,
  b5 as OptionalItem,
  h5 as RuleItem,
  k5 as SeparatedList,
  j5 as SeparatedListKind,
  l5 as SimpleItem,
  m5 as SimpleList,
  n5 as TangibleItem,
  o5 as Terminal,
  e2 as GrammarTypeNamespaceAbstract,
  f2 as GrammarTypeNamespaceSimple,
  d2 as GrammarTypeModelBuilder,
  o1 as AglGrammarGrammar,
  p1 as AglGrammarSemanticAnalyser,
  q1 as AglGrammarSyntaxAnalyser,
  r1 as ContextFromGrammar,
  s1 as ConverterToRuntimeRules,
  t1 as GrammarContext,
  s as GrammarBuilderDefault,
  r as GrammarAbstract,
  t as GrammarDefault,
  v as GrammarOptionDefault,
  w as GrammarReferenceDefault,
  u as GrammarItemAbstract,
  x as GrammarRuleAbstract,
  a1 as NamespaceDefault,
  b1 as NodeTypeDefault,
  d1 as NormalRuleDefault,
  f1 as OverrideRuleDefault,
  g1 as PreferenceOptionDefault,
  h1 as PreferenceRuleDefault,
  j as ChoiceAbstract,
  k as ChoiceAmbiguousDefault,
  l as ChoiceLongestDefault,
  m as ChoicePriorityDefault,
  n as ConcatenationDefault,
  o as ConcatenationItemAbstract,
  p as EmbeddedDefault,
  q as EmptyRuleDefault,
  y as GroupDefault,
  z as ListOfItemsAbstract,
  c1 as NonTerminalDefault,
  e1 as OptionalItemDefault,
  i1 as RuleItemAbstract,
  j1 as SeparatedListDefault,
  k1 as SimpleItemAbstract,
  l1 as SimpleListDefault,
  m1 as TangibleItemAbstract,
  n1 as TerminalDefault,
  c3 as ContextFromTypeModel,
  d3 as ContextSimple,
  g3 as ScopeSimple,
  h3 as SyntaxAnalyserByMethodRegistrationAbstract,
  i3 as SyntaxAnalyserFromTreeDataAbstract,
  b3 as ChildData,
  e3 as DownData,
  f3 as NodeTypes,
  j3 as SyntaxAnalyserSimpleAbstract,
  k3 as SyntaxAnalyserSimpleStreamPushAbstract,
  l2 as CountTreesVisitor,
  q2 as SPPTFromTreeData,
  m2 as NodeStart,
  o2 as QName,
  p2 as RuleReference,
  r2 as SPPTParserDefault,
  s2 as SimpleScanner,
  x2 as Tokens,
  a3 as TreeParser,
  v2 as ToStringVisitor,
  w2 as TokensByLineVisitor,
  k2 as CompleteTreeDataNode,
  n2 as PreferredNode,
  y2 as TreeDataComplete,
  j2 as AlternativesInfo,
  t2 as StackData,
  u2 as StackInfo,
  z2 as TreeDataWalkerDepthFirst,
  u1 as AglScopesGrammar,
  v1 as AglScopesSyntaxAnalyser,
  w1 as Identifiable,
  x1 as ReferenceDefinition,
  y1 as ScopeDefinition,
  z1 as ScopeModelAgl,
  a2 as AglStyleGrammar,
  c2 as AglStyleSyntaxAnalyser,
  b2 as AglStyleModelDefault,
  h as Agl_getInstance,
} from './net.akehurst.language-agl-processor.mjs';
import { a as KotlinxReflect_getInstance } from './net.akehurst.kotlinx-kotlinx-reflect.mjs';
import {
  s as CollectionTypeSimple,
  t as DataTypeSimple,
  u as EnumTypeSimple,
  v as PrimitiveTypeSimple,
  w as PropertyDeclarationSimple,
  x as SimpleTypeModelStdLib,
  y as SpecialTypeSimple,
  z as StructuredTypeSimpleAbstract,
  a1 as TupleTypeInstance,
  b1 as TupleTypeSimple,
  c1 as TypeDefinitionSimpleAbstract,
  d1 as TypeInstanceAbstract,
  e1 as TypeInstanceSimple,
  g1 as TypeModelSimple,
  f1 as TypeModelSimpleAbstract,
  h1 as TypeNamespaceAbstract,
  i1 as TypeNamespaceSimple,
  j1 as UnnamedSuperTypeTypeInstance,
  k1 as UnnamedSuperTypeTypeSimple,
  r as typeModel,
} from './net.akehurst.language-type-model.mjs';
import {
  l as AglEditorLogger,
  m as AglEditor,
  f as LogLevel_Error_getInstance,
  e as LogLevel_Debug_getInstance,
  b as EventStatus_START_getInstance,
  o as ParseEvent,
  a as EventStatus_FAILURE_getInstance,
  c as EventStatus_SUCCESS_getInstance,
  q as SyntaxAnalysisEvent,
  p as SemanticAnalysisEvent,
  j as LogLevel_Trace_getInstance,
} from './net.akehurst.language.editor-agl-editor-api.mjs';
import { a as KSerialiserJson } from './net.akehurst.kotlin.kserialisation-kserialisation-json.mjs';
import { j as Companion_getInstance } from './net.akehurst.kotlin.json-json.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class BuildConfig_0 {
  constructor() {
    BuildConfig_instance = this;
    this.version = '1.9.20-Beta';
    this.buildStamp = '2023-09-29T11:11:46.841284Z[UTC]';
    this.buildDate = '2023-Sept-29';
    this.buildTime = '11:11:46 UTC';
  }
  nt() {
    return this.version;
  }
  ot() {
    return this.buildStamp;
  }
  pt() {
    return this.buildDate;
  }
  qt() {
    return this.buildTime;
  }
}
class KotlinxReflectForModule_0 {
  constructor() {
    KotlinxReflectForModule_instance = this;
  }
  y4m() {
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglTokenizerByWorker', getKClass(AglTokenizerByWorker), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglTokenizer', getKClass(AglTokenizer), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglStyleHandler', getKClass(AglStyleHandler), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglLineState', getKClass(AglLineState), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglLoggerToConsole', getKClass(AglLoggerToConsole), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglWorkerSerialisation', getKClass(AglWorkerSerialisation_0), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglToken', getKClass(AglToken), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglWorkerClient', getKClass(AglWorkerClient), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglEditorAbstract', getKClass(AglEditorAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglComponents', getKClass(AglComponents), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.AglEditorJsAbstract', getKClass(AglEditorJsAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageParserInterruptRequest', getKClass(MessageParserInterruptRequest), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageProcessorDelete', getKClass(MessageProcessorDelete), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageSyntaxAnalyserConfigureResponse', getKClass(MessageSyntaxAnalyserConfigureResponse), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageSetStyleResult', getKClass(MessageSetStyleResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageProcessRequest', getKClass(MessageProcessRequest), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageGrammarAmbiguityAnalysisRequest', getKClass(MessageGrammarAmbiguityAnalysisRequest), null);
    var tmp = KotlinxReflect_getInstance();
    var tmp_0 = getKClass(MessageStatus);
    tmp.z4d('net.akehurst.language.editor.common.messages.MessageStatus', tmp_0, MessageStatus$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageSyntaxAnalysisResult', getKClass(MessageSyntaxAnalysisResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageProcessorCreateResponse', getKClass(MessageProcessorCreateResponse), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageLineTokens', getKClass(MessageLineTokens), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageCodeCompleteResult', getKClass(MessageCodeCompleteResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageProcessorDeleteResponse', getKClass(MessageProcessorDeleteResponse), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageSetStyle', getKClass(MessageSetStyle), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.AglWorkerMessage', getKClass(AglWorkerMessage), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageSyntaxAnalyserConfigure', getKClass(MessageSyntaxAnalyserConfigure), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageParseResult', getKClass(MessageParseResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageSemanticAnalysisResult', getKClass(MessageSemanticAnalysisResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageCodeCompleteRequest', getKClass(MessageCodeCompleteRequest), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageGrammarAmbiguityAnalysisResult', getKClass(MessageGrammarAmbiguityAnalysisResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.editor.common.messages.MessageProcessorCreate', getKClass(MessageProcessorCreate), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.automaton.AglAutomatonDslMarker', getKClass(AglAutomatonDslMarker), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.automaton.Automaton', getKClass(Automaton), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.automaton.AutomatonBuilder', getKClass(AutomatonBuilder), null);
    var tmp_1 = KotlinxReflect_getInstance();
    var tmp_2 = getKClass(ParseAction);
    tmp_1.z4d('net.akehurst.language.api.automaton.ParseAction', tmp_2, ParseAction$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.automaton.TransitionBuilder', getKClass(TransitionBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.Scope', getKClass(Scope), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmElementPath', getKClass(AsmElementPath), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmElementProperty', getKClass(AsmElementProperty), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmElementReference', getKClass(AsmElementReference), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmElementSimple', getKClass(AsmElementSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmSimple', getKClass(AsmSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmSimpleTreeWalker', getKClass(AsmSimpleTreeWalker), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmElementSimpleBuilder', getKClass(AsmElementSimpleBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmSimpleBuilder', getKClass(AsmSimpleBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.AsmSimpleBuilderMarker', getKClass(AsmSimpleBuilderMarker), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.asm.ListAsmElementSimpleBuilder', getKClass(ListAsmElementSimpleBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.parser.InputLocation', getKClass(InputLocation), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.parser.ParseTreeException', getKClass(ParseTreeException), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.parser.ParserConstructionFailedException', getKClass(ParserConstructionFailedException), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.parser.ParseFailedException', getKClass(ParseFailedException), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.parser.ParserException', getKClass(ParserException), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.parser.ParserTerminatedException', getKClass(ParserTerminatedException), null);
    var tmp_3 = KotlinxReflect_getInstance();
    var tmp_4 = getKClass(AutomatonKind);
    tmp_3.z4d('net.akehurst.language.api.processor.AutomatonKind', tmp_4, AutomatonKind$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.AutomatonKind_api', getKClass(AutomatonKind_api), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.CompletionItem', getKClass(CompletionItem), null);
    var tmp_5 = KotlinxReflect_getInstance();
    var tmp_6 = getKClass(CompletionItemKind);
    tmp_5.z4d('net.akehurst.language.api.processor.CompletionItemKind', tmp_6, CompletionItemKind$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.CompletionProvider', getKClass(CompletionProvider), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.Formatter', getKClass(Formatter), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.GrammarRegistry', getKClass(GrammarRegistry), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageDefinition', getKClass(LanguageDefinition), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageRegistry', getKClass(LanguageRegistry), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageProcessor', getKClass(LanguageProcessor), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageProcessorException', getKClass(LanguageProcessorException), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SentenceContext', getKClass(SentenceContext), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageIssue', getKClass(LanguageIssue), null);
    var tmp_7 = KotlinxReflect_getInstance();
    var tmp_8 = getKClass(LanguageIssueKind);
    tmp_7.z4d('net.akehurst.language.api.processor.LanguageIssueKind', tmp_8, LanguageIssueKind$values$ref());
    var tmp_9 = KotlinxReflect_getInstance();
    var tmp_10 = getKClass(LanguageProcessorPhase);
    tmp_9.z4d('net.akehurst.language.api.processor.LanguageProcessorPhase', tmp_10, LanguageProcessorPhase$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.CompletionProviderOptions', getKClass(CompletionProviderOptions), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageProcessorConfiguration', getKClass(LanguageProcessorConfiguration), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ParseOptions', getKClass(ParseOptions), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ProcessOptions', getKClass(ProcessOptions), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SemanticAnalysisOptions', getKClass(SemanticAnalysisOptions), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SyntaxAnalysisOptions', getKClass(SyntaxAnalysisOptions), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.CompletionProviderOptionsBuilder', getKClass(CompletionProviderOptionsBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.CompletionProviderOptionsDefault', getKClass(CompletionProviderOptionsDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageProcessorConfigurationBuilder', getKClass(LanguageProcessorConfigurationBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageProcessorConfigurationDefault', getKClass(LanguageProcessorConfigurationDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.LanguageProcessorConfigurationDslMarker', getKClass(LanguageProcessorConfigurationDslMarker), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ParseOptionsBuilder', getKClass(ParseOptionsBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ParseOptionsDefault', getKClass(ParseOptionsDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ProcessOptionsBuilder', getKClass(ProcessOptionsBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ProcessOptionsDefault', getKClass(ProcessOptionsDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ProcessOptionsDslMarker', getKClass(ProcessOptionsDslMarker), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SemanticAnalysisOptionsBuilder', getKClass(SemanticAnalysisOptionsBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SemanticAnalysisOptionsDefault', getKClass(SemanticAnalysisOptionsDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SyntaxAnalysisOptionsBuilder', getKClass(SyntaxAnalysisOptionsBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SyntaxAnalysisOptionsDefault', getKClass(SyntaxAnalysisOptionsDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ExpectedAtResult', getKClass(ExpectedAtResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.FormatResult', getKClass(FormatResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.IssueCollection', getKClass(IssueCollection), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ParseResult', getKClass(ParseResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.ProcessResult', getKClass(ProcessResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SemanticAnalysisResult', getKClass(SemanticAnalysisResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.processor.SyntaxAnalysisResult', getKClass(SyntaxAnalysisResult), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.style.AglStyle', getKClass(AglStyle), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.style.AglStyleModel', getKClass(AglStyleModel), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.style.AglStyleRule', getKClass(AglStyleRule), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.style.AglStyleSelector', getKClass(AglStyleSelector), null);
    var tmp_11 = KotlinxReflect_getInstance();
    var tmp_12 = getKClass(AglStyleSelectorKind);
    tmp_11.z4d('net.akehurst.language.api.style.AglStyleSelectorKind', tmp_12, AglStyleSelectorKind$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.Grammar', getKClass(Grammar), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarItem', getKClass(GrammarItem), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarOption', getKClass(GrammarOption), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarReference', getKClass(GrammarReference), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarExeception', getKClass(GrammarExeception), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarLoader', getKClass(GrammarLoader), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarRegistry', getKClass(GrammarRegistry_0), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarRule', getKClass(GrammarRule), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.NormalRule', getKClass(NormalRule), null);
    var tmp_13 = KotlinxReflect_getInstance();
    var tmp_14 = getKClass(OverrideKind);
    tmp_13.z4d('net.akehurst.language.api.grammar.OverrideKind', tmp_14, OverrideKind$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.OverrideRule', getKClass(OverrideRule), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.PreferenceOption', getKClass(PreferenceOption), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.PreferenceRule', getKClass(PreferenceRule), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarRuleItemNotFoundException', getKClass(GrammarRuleItemNotFoundException), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.GrammarRuleNotFoundException', getKClass(GrammarRuleNotFoundException), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.Namespace', getKClass(Namespace), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.NodeType', getKClass(NodeType), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.Choice', getKClass(Choice), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.ChoiceAmbiguous', getKClass(ChoiceAmbiguous), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.ChoiceLongest', getKClass(ChoiceLongest), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.ChoicePriority', getKClass(ChoicePriority), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.Concatenation', getKClass(Concatenation), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.ConcatenationItem', getKClass(ConcatenationItem), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.Embedded', getKClass(Embedded), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.EmptyRule', getKClass(EmptyRule), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.Group', getKClass(Group), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.ListOfItems', getKClass(ListOfItems), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.NonTerminal', getKClass(NonTerminal), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.OptionalItem', getKClass(OptionalItem), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.RuleItem', getKClass(RuleItem), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.SeparatedList', getKClass(SeparatedList), null);
    var tmp_15 = KotlinxReflect_getInstance();
    var tmp_16 = getKClass(SeparatedListKind);
    tmp_15.z4d('net.akehurst.language.api.grammar.SeparatedListKind', tmp_16, SeparatedListKind$values$ref());
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.SimpleItem', getKClass(SimpleItem), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.SimpleList', getKClass(SimpleList), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.TangibleItem', getKClass(TangibleItem), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.api.grammar.Terminal', getKClass(Terminal), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.CollectionTypeSimple', getKClass(CollectionTypeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.DataTypeSimple', getKClass(DataTypeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.EnumTypeSimple', getKClass(EnumTypeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.PrimitiveTypeSimple', getKClass(PrimitiveTypeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.PropertyDeclarationSimple', getKClass(PropertyDeclarationSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.SimpleTypeModelStdLib', getKClass(SimpleTypeModelStdLib), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.SpecialTypeSimple', getKClass(SpecialTypeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.StructuredTypeSimpleAbstract', getKClass(StructuredTypeSimpleAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TupleTypeInstance', getKClass(TupleTypeInstance), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TupleTypeSimple', getKClass(TupleTypeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TypeDefinitionSimpleAbstract', getKClass(TypeDefinitionSimpleAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TypeInstanceAbstract', getKClass(TypeInstanceAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TypeInstanceSimple', getKClass(TypeInstanceSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TypeModelSimple', getKClass(TypeModelSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TypeModelSimpleAbstract', getKClass(TypeModelSimpleAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TypeNamespaceAbstract', getKClass(TypeNamespaceAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.TypeNamespaceSimple', getKClass(TypeNamespaceSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.UnnamedSuperTypeTypeInstance', getKClass(UnnamedSuperTypeTypeInstance), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.typemodel.simple.UnnamedSuperTypeTypeSimple', getKClass(UnnamedSuperTypeTypeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammarTypeModel.GrammarTypeNamespaceAbstract', getKClass(GrammarTypeNamespaceAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammarTypeModel.GrammarTypeNamespaceSimple', getKClass(GrammarTypeNamespaceSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammarTypeModel.GrammarTypeModelBuilder', getKClass(GrammarTypeModelBuilder), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.AglGrammarGrammar', getKClass(AglGrammarGrammar), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser', getKClass(AglGrammarSemanticAnalyser), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser', getKClass(AglGrammarSyntaxAnalyser), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.ContextFromGrammar', getKClass(ContextFromGrammar), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules', getKClass(ConverterToRuntimeRules), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.GrammarContext', getKClass(GrammarContext), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GrammarBuilderDefault', getKClass(GrammarBuilderDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract', getKClass(GrammarAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GrammarDefault', getKClass(GrammarDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GrammarOptionDefault', getKClass(GrammarOptionDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GrammarReferenceDefault', getKClass(GrammarReferenceDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GrammarItemAbstract', getKClass(GrammarItemAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GrammarRuleAbstract', getKClass(GrammarRuleAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.NamespaceDefault', getKClass(NamespaceDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.NodeTypeDefault', getKClass(NodeTypeDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.NormalRuleDefault', getKClass(NormalRuleDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.OverrideRuleDefault', getKClass(OverrideRuleDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.PreferenceOptionDefault', getKClass(PreferenceOptionDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.PreferenceRuleDefault', getKClass(PreferenceRuleDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.ChoiceAbstract', getKClass(ChoiceAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.ChoiceAmbiguousDefault', getKClass(ChoiceAmbiguousDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.ChoiceLongestDefault', getKClass(ChoiceLongestDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.ChoicePriorityDefault', getKClass(ChoicePriorityDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.ConcatenationDefault', getKClass(ConcatenationDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.ConcatenationItemAbstract', getKClass(ConcatenationItemAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.EmbeddedDefault', getKClass(EmbeddedDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.EmptyRuleDefault', getKClass(EmptyRuleDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.GroupDefault', getKClass(GroupDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.ListOfItemsAbstract', getKClass(ListOfItemsAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.NonTerminalDefault', getKClass(NonTerminalDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.OptionalItemDefault', getKClass(OptionalItemDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.RuleItemAbstract', getKClass(RuleItemAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.SeparatedListDefault', getKClass(SeparatedListDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.SimpleItemAbstract', getKClass(SimpleItemAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.SimpleListDefault', getKClass(SimpleListDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.TangibleItemAbstract', getKClass(TangibleItemAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.grammar.asm.TerminalDefault', getKClass(TerminalDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.ContextFromTypeModel', getKClass(ContextFromTypeModel), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.ContextSimple', getKClass(ContextSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.ScopeSimple', getKClass(ScopeSimple), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserByMethodRegistrationAbstract', getKClass(SyntaxAnalyserByMethodRegistrationAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserFromTreeDataAbstract', getKClass(SyntaxAnalyserFromTreeDataAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.ChildData', getKClass(ChildData), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.DownData', getKClass(DownData), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.NodeTypes', getKClass(NodeTypes), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract', getKClass(SyntaxAnalyserSimpleAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleStreamPushAbstract', getKClass(SyntaxAnalyserSimpleStreamPushAbstract), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.CountTreesVisitor', getKClass(CountTreesVisitor), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.SPPTFromTreeData', getKClass(SPPTFromTreeData), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.NodeStart', getKClass(NodeStart), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.QName', getKClass(QName), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.RuleReference', getKClass(RuleReference), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.SPPTParserDefault', getKClass(SPPTParserDefault), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.SimpleScanner', getKClass(SimpleScanner), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.Tokens', getKClass(Tokens), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.TreeParser', getKClass(TreeParser), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.ToStringVisitor', getKClass(ToStringVisitor), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.TokensByLineVisitor', getKClass(TokensByLineVisitor), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.CompleteTreeDataNode', getKClass(CompleteTreeDataNode), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.PreferredNode', getKClass(PreferredNode), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.TreeDataComplete', getKClass(TreeDataComplete), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.AlternativesInfo', getKClass(AlternativesInfo), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.StackData', getKClass(StackData), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.StackInfo', getKClass(StackInfo), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst', getKClass(TreeDataWalkerDepthFirst), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.scopes.AglScopesGrammar', getKClass(AglScopesGrammar), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.scopes.AglScopesSyntaxAnalyser', getKClass(AglScopesSyntaxAnalyser), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.scopes.Identifiable', getKClass(Identifiable), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.scopes.ReferenceDefinition', getKClass(ReferenceDefinition), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.scopes.ScopeDefinition', getKClass(ScopeDefinition), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.scopes.ScopeModelAgl', getKClass(ScopeModelAgl), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.style.AglStyleGrammar', getKClass(AglStyleGrammar), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.style.AglStyleSyntaxAnalyser', getKClass(AglStyleSyntaxAnalyser), null);
    KotlinxReflect_getInstance().z4d('net.akehurst.language.agl.grammar.style.AglStyleModelDefault', getKClass(AglStyleModelDefault), null);
  }
  z4m(qualifiedName) {
    this.y4m();
    return KotlinxReflect_getInstance().a4e(qualifiedName);
  }
}
class AglComponents {
  constructor(languageId, editorId, logger) {
    this.editorId = editorId;
    this.logger = logger;
    this.a4n_1 = new AglStyleHandler(languageId);
    this.b4n_1 = languageId;
    this.goalRule = this.languageDefinition.defaultGoalRule;
    this.context = null;
    this.sppt = null;
  }
  y4c() {
    return this.editorId;
  }
  j4d() {
    return this.logger;
  }
  b4d() {
    return Agl_getInstance().registry.findOrPlaceholder(this.b4n_1, null, Agl_getInstance().configurationEmpty());
  }
  c4n(_set____db54di) {
    this.goalRule = _set____db54di;
  }
  pv() {
    return this.goalRule;
  }
  d4n() {
    return this.a4n_1;
  }
  v2l(_set____db54di) {
    this.context = _set____db54di;
  }
  uf() {
    return this.context;
  }
  e4n(_set____db54di) {
    this.sppt = _set____db54di;
  }
  s25() {
    return this.sppt;
  }
  z4c(value) {
    if (this.languageDefinition.identity === value) {
    } else {
      var old = this.languageDefinition;
      var grammarStrObservers = old.grammarStrObservers;
      var scopeStrObservers = old.scopeStrObservers;
      var styleStrObservers = old.styleStrObservers;
      var formatterStrObservers = old.formatterStrObservers;
      this.b4n_1 = value;
      var new_0 = this.languageDefinition;
      new_0.grammarStrObservers.k1(grammarStrObservers);
      new_0.scopeStrObservers.k1(scopeStrObservers);
      new_0.styleStrObservers.k1(styleStrObservers);
      new_0.formatterStrObservers.k1(formatterStrObservers);
      this.a4n_1 = new AglStyleHandler(value);
      this.sppt = null;
    }
  }
  a4d() {
    return this.languageDefinition.identity;
  }
  get languageDefinition() {
    return this.b4d();
  }
  get styleHandler() {
    return this.d4n();
  }
  get languageIdentity() {
    return this.a4d();
  }
  set languageIdentity(value) {
    this.z4c(value);
  }
}
class AglEditorAbstract {
  constructor(languageId, editorId, logFunction) {
    this.editorId = editorId;
    this.logger = new AglEditorLogger(logFunction);
    this.agl = new AglComponents(languageId, this.editorId, this.logger);
    var tmp = this.agl.languageDefinition.grammarStrObservers;
    tmp.e1(AglEditorAbstract$lambda(this));
    var tmp_0 = this.agl.languageDefinition.scopeStrObservers;
    tmp_0.e1(AglEditorAbstract$lambda_0(this));
    var tmp_1 = this.agl.languageDefinition.styleStrObservers;
    tmp_1.e1(AglEditorAbstract$lambda_1(this));
    var tmp_2 = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp_2.f4n_1 = tmp$ret$0;
    var tmp_3 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_3.g4n_1 = tmp$ret$1;
    var tmp_4 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$2 = ArrayList.i4();
    tmp_4.h4n_1 = tmp$ret$2;
    this.i4n_1 = null;
    this.j4n_1 = true;
  }
  y4c() {
    return this.editorId;
  }
  j4d() {
    return this.logger;
  }
  c25() {
    return this.agl;
  }
  z4c(value) {
    var oldId = this.agl.languageIdentity;
    if (oldId === value) {
    } else {
      this.agl.languageIdentity = value;
      this.updateLanguage(oldId);
      this.updateProcessor();
      this.updateStyle();
    }
  }
  a4d() {
    return this.agl.languageIdentity;
  }
  b4d() {
    return this.agl.languageDefinition;
  }
  m2l(value) {
    this.agl.goalRule = value;
  }
  n2l() {
    return this.agl.goalRule;
  }
  c4d(value) {
    this.i4n_1 = value;
    this.updateStyle();
  }
  d4d() {
    var tmp0_elvis_lhs = this.i4n_1;
    return tmp0_elvis_lhs == null ? this.agl.languageDefinition.styleStr : tmp0_elvis_lhs;
  }
  e4d(value) {
    this.agl.context = value;
    this.processSentence();
  }
  f4d() {
    return this.agl.context;
  }
  h4d(_set____db54di) {
    this.j4n_1 = _set____db54di;
  }
  i4d() {
    return this.j4n_1;
  }
  onParse(handler) {
    this.f4n_1.e1(handler);
  }
  onSyntaxAnalysis(handler) {
    this.g4n_1.e1(handler);
  }
  onSemanticAnalysis(handler) {
    this.h4n_1.e1(handler);
  }
  log(level, message, t) {
    return this.logger.log(level, message, t);
  }
  notifyParse(event) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.f4n_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.editor.common.AglEditorAbstract.notifyParse.<anonymous>' call
      element(event);
    }
  }
  notifySyntaxAnalysis(event) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.g4n_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.editor.common.AglEditorAbstract.notifySyntaxAnalysis.<anonymous>' call
      element(event);
    }
  }
  notifySemanticAnalysis(event) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.h4n_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.editor.common.AglEditorAbstract.notifySemanticAnalysis.<anonymous>' call
      element(event);
    }
  }
  get sessionId() {
    return this.k4n();
  }
  get languageIdentity() {
    return this.a4d();
  }
  set languageIdentity(value) {
    this.z4c(value);
  }
  get languageDefinition() {
    return this.b4d();
  }
  get goalRuleName() {
    return this.n2l();
  }
  set goalRuleName(value) {
    this.m2l(value);
  }
  get editorSpecificStyleStr() {
    return this.d4d();
  }
  set editorSpecificStyleStr(value) {
    this.c4d(value);
  }
  get sentenceContext() {
    return this.f4d();
  }
  set sentenceContext(value) {
    this.e4d(value);
  }
  get doUpdate() {
    return this.i4d();
  }
  set doUpdate(value) {
    this.h4d(value);
  }
  get baseEditor() {
    return this.x4c();
  }
  get text() {
    return this.u1p();
  }
  set text(value) {
    this.g4d(value);
  }
}
class AglLoggerToConsole {
  constructor(level) {
    this.level = level;
  }
  l4n(_set____db54di) {
    this.level = _set____db54di;
  }
  u36() {
    return this.level;
  }
  logFatal(msg) {
    return println('Fatal: ' + msg);
  }
  logError(msg) {
    return println('Error: ' + msg);
  }
  logWarn(msg) {
    return println('Warn: ' + msg);
  }
  logInfo(msg) {
    return println('Info: ' + msg);
  }
  logDebug(msg) {
    return println('Debug: ' + msg);
  }
  logTrace(msg) {
    return println('Trace: ' + msg);
  }
  log(lvl, msg, t) {
    if (lvl.cc(this.level) <= 0) {
      logAll(this, lvl, msg, t);
    } else
    ;
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
  }
  languageIdToStyleClass(cssClassPrefixStart, languageId) {
    var tmp$ret$0;
    // Inline function 'kotlin.text.replace' call
    var tmp0_replace = Regex.hb('[^a-z0-9A-Z_-]');
    tmp$ret$0 = tmp0_replace.ob(languageId, '_');
    var cssLangId = tmp$ret$0;
    return cssClassPrefixStart + '_' + cssLangId;
  }
}
class AglStyleHandler {
  constructor(languageId, cssClassPrefixStart) {
    Companion_getInstance_0();
    cssClassPrefixStart = cssClassPrefixStart === VOID ? 'agl' : cssClassPrefixStart;
    this.cssClassPrefixStart = cssClassPrefixStart;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.text.replace' call
    var tmp0_replace = Regex.hb('[^a-z0-9A-Z_-]');
    tmp$ret$0 = tmp0_replace.ob(languageId, '_');
    tmp.cssLanguageId = tmp$ret$0;
    this.aglStyleClass = Companion_getInstance_0().languageIdToStyleClass(this.cssClassPrefixStart, languageId);
    this.m4n_1 = 1;
    this.n4n_1 = this.aglStyleClass + '-';
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.o4n_1 = tmp$ret$1;
  }
  p4n() {
    return this.cssClassPrefixStart;
  }
  q4n() {
    return this.cssLanguageId;
  }
  r4n() {
    return this.aglStyleClass;
  }
  transformToTokens(leafs) {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(leafs, 10));
    var tmp0_iterator = leafs.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.editor.common.AglStyleHandler.transformToTokens.<anonymous>' call
      var cssClasses = mapToCssClasses(this, item);
      var beforeEOL = item.matchedText;
      var eolIndex = indexOf(item.matchedText, _Char___init__impl__6a9atx(10));
      if (!(-1 === eolIndex)) {
        var tmp$ret$1;
        // Inline function 'kotlin.text.substring' call
        var tmp0_substring = item.matchedText;
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp0_substring;
        tmp$ret$1 = tmp$ret$0.substring(0, eolIndex);
        beforeEOL = tmp$ret$1;
      }
      var tmp$ret$2;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp1_toTypedArray = toSet(cssClasses);
      tmp$ret$2 = copyToArray(tmp1_toTypedArray);
      tmp$ret$3 = new AglToken(tmp$ret$2, beforeEOL, item.location.line, item.location.column);
      tmp0_mapTo.e1(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo;
    tmp$ret$5 = tmp$ret$4;
    return tmp$ret$5;
  }
  reset() {
    this.o4n_1.n1();
    this.m4n_1 = 1;
  }
  mapClass(aglSelector) {
    var cssClass = this.o4n_1.u3(aglSelector);
    if (null == cssClass) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.m4n_1;
      tmp0_this.m4n_1 = tmp1 + 1 | 0;
      cssClass = this.n4n_1 + tmp1;
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.o4n_1;
      var tmp1_set = cssClass;
      tmp0_set.m3(aglSelector, tmp1_set);
    }
    return cssClass;
  }
  static get Companion() {
    return Companion_getInstance_0();
  }
}
class AglTokenizerByWorker {}
class AglLineState {
  constructor(lineNumber, leftOverText, tokens) {
    this.lineNumber = lineNumber;
    this.leftOverText = leftOverText;
    this.tokens = tokens;
  }
  v4n() {
    return this.lineNumber;
  }
  w4n() {
    return this.leftOverText;
  }
  x4n() {
    return this.tokens;
  }
}
class AglToken {
  constructor(styles, value, line, column) {
    this.styles = styles;
    this.value = value;
    this.line = line;
    this.column = column;
  }
  l2p() {
    return this.styles;
  }
  p3() {
    return this.value;
  }
  v2j() {
    return this.line;
  }
  u2j() {
    return this.column;
  }
}
class AglTokenizer {
  constructor(agl) {
    this.agl = agl;
  }
  c25() {
    return this.agl;
  }
  getLineTokens(lineText, pState, line) {
    var sppt = this.agl.sppt;
    var tmp;
    if (null == sppt) {
      tmp = this.getLineTokensByScan(lineText, pState, line);
    } else {
      tmp = this.getLineTokensByParse(lineText, pState, line);
    }
    return tmp;
  }
  transformToTokens(leafs) {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(leafs, 10));
    var tmp0_iterator = leafs.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.editor.common.AglTokenizer.transformToTokens.<anonymous>' call
      var cssClasses = mapToCssClasses_0(this, item);
      var beforeEOL = item.matchedText;
      var eolIndex = indexOf(item.matchedText, _Char___init__impl__6a9atx(10));
      if (!(-1 === eolIndex)) {
        var tmp$ret$1;
        // Inline function 'kotlin.text.substring' call
        var tmp0_substring = item.matchedText;
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp0_substring;
        tmp$ret$1 = tmp$ret$0.substring(0, eolIndex);
        beforeEOL = tmp$ret$1;
      }
      var tmp$ret$2;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp1_toTypedArray = toSet(cssClasses);
      tmp$ret$2 = copyToArray(tmp1_toTypedArray);
      tmp$ret$3 = new AglToken(tmp$ret$2, beforeEOL, item.location.line, item.location.column);
      tmp0_mapTo.e1(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo;
    tmp$ret$5 = tmp$ret$4;
    return tmp$ret$5;
  }
  getLineTokensByScan(lineText, state, row) {
    var tmp;
    try {
      var proc = this.agl.languageDefinition.processor;
      var tmp_0;
      if (!(null == proc)) {
        var text = state.leftOverText + lineText;
        var leafs = proc.scan(text);
        var tokens = this.transformToTokens(leafs);
        var tmp_1;
        if (leafs.y()) {
          tmp_1 = new AglLineState(row, '', emptyList());
        } else {
          var lastLeaf = last(leafs);
          var endOfLastLeaf = lastLeaf.location.column + lastLeaf.location.length | 0;
          var tmp$ret$1;
          // Inline function 'kotlin.text.substring' call
          var tmp0_substring = lineText.length;
          var tmp$ret$0;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$0 = lineText;
          tmp$ret$1 = tmp$ret$0.substring(endOfLastLeaf, tmp0_substring);
          var leftOverText = tmp$ret$1;
          tmp_1 = new AglLineState(row, leftOverText, tokens);
        }
        tmp_0 = tmp_1;
      } else {
        var tmp$ret$4;
        // Inline function 'kotlin.arrayOf' call
        var tmp$ret$3;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$2;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$2 = ['nostyle'];
        tmp$ret$3 = tmp$ret$2;
        tmp$ret$4 = tmp$ret$3;
        tmp_0 = new AglLineState(row, '', listOf(new AglToken(tmp$ret$4, lineText, row, 0)));
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var t = $p;
        this.agl.logger.log(LogLevel_Error_getInstance(), 'Unable to create LanguageProcessor', t);
        var tmp$ret$7;
        // Inline function 'kotlin.arrayOf' call
        var tmp$ret$6;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$5;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$5 = ['nostyle'];
        tmp$ret$6 = tmp$ret$5;
        tmp$ret$7 = tmp$ret$6;
        tmp_2 = new AglLineState(row, '', listOf(new AglToken(tmp$ret$7, lineText, row, 0)));
      } else {
        throw $p;
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  getLineTokensByParse(lineText, state, row) {
    var sppt = ensureNotNull(this.agl.sppt);
    var leafs = sppt.tokensByLine(row);
    var tokens = this.transformToTokens(leafs);
    var endState = new AglLineState(row, '', tokens);
    return endState;
  }
}
class AglWorkerSerialisation_0 {
  constructor() {
    AglWorkerSerialisation_instance = this;
    this.y4n_1 = false;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new KSerialiserJson();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.editor.common.AglWorkerSerialisation.serialiser.<anonymous>' call
    tmp0_also.registerKotlinStdPrimitives();
    tmp$ret$0 = tmp0_also;
    tmp.z4n_1 = tmp$ret$0;
  }
  confgureFromKompositeString(datatypeModel) {
    this.z4n_1.confgureFromKompositeString(datatypeModel);
  }
  confgureFromKompositeModel(datatypeModel) {
    this.z4n_1.confgureFromKompositeModel(datatypeModel);
  }
  a4o(obj) {
    if (!this.y4n_1) {
      initialise(this);
    }
    return this.z4n_1.toJson(obj, obj);
  }
  serialise(obj) {
    return this.a4o(obj).y4e();
  }
  deserialise(jsonString) {
    if (!this.y4n_1) {
      initialise(this);
    }
    return this.z4n_1.toData(jsonString);
  }
}
class MessageStatus extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get START() {
    return MessageStatus_START_getInstance();
  }
  static get FAILURE() {
    return MessageStatus_FAILURE_getInstance();
  }
  static get SUCCESS() {
    return MessageStatus_SUCCESS_getInstance();
  }
}
class AglWorkerMessage {
  constructor(action) {
    this.action = action;
  }
  d4o() {
    return this.action;
  }
  get languageId() {
    return this.e4o();
  }
  get editorId() {
    return this.y4c();
  }
  get sessionId() {
    return this.k4n();
  }
}
class MessageProcessorCreate extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, grammarStr, scopeModelStr) {
    super('MessageProcessorCreate');
    this.f4o_1 = languageId;
    this.g4o_1 = editorId;
    this.h4o_1 = sessionId;
    this.grammarStr = grammarStr;
    this.scopeModelStr = scopeModelStr;
  }
  e4o() {
    return this.f4o_1;
  }
  y4c() {
    return this.g4o_1;
  }
  k4n() {
    return this.h4o_1;
  }
  u1x() {
    return this.grammarStr;
  }
  c1y() {
    return this.scopeModelStr;
  }
  toString() {
    var gs = isBlank(this.grammarStr) ? "''" : "'...'";
    var ss = null == this.scopeModelStr ? 'null' : isBlank(this.scopeModelStr) ? "''" : "'...'";
    return this.action + '(languageId=' + this.f4o_1 + ', editorId=' + this.g4o_1 + ', sessionId=' + this.h4o_1 + ', grammarStr=' + gs + ', scopeModelStr=' + ss + ')';
  }
  ti() {
    return this.f4o_1;
  }
  ui() {
    return this.g4o_1;
  }
  r1j() {
    return this.h4o_1;
  }
  s1j() {
    return this.grammarStr;
  }
  t1j() {
    return this.scopeModelStr;
  }
  i4o(languageId, editorId, sessionId, grammarStr, scopeModelStr) {
    return new MessageProcessorCreate(languageId, editorId, sessionId, grammarStr, scopeModelStr);
  }
  copy(languageId, editorId, sessionId, grammarStr, scopeModelStr, $super) {
    languageId = languageId === VOID ? this.f4o_1 : languageId;
    editorId = editorId === VOID ? this.g4o_1 : editorId;
    sessionId = sessionId === VOID ? this.h4o_1 : sessionId;
    grammarStr = grammarStr === VOID ? this.grammarStr : grammarStr;
    scopeModelStr = scopeModelStr === VOID ? this.scopeModelStr : scopeModelStr;
    return this.i4o(languageId, editorId, sessionId, grammarStr, scopeModelStr);
  }
  hashCode() {
    var result = getStringHashCode(this.f4o_1);
    result = imul(result, 31) + getStringHashCode(this.g4o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h4o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.grammarStr) | 0;
    result = imul(result, 31) + (this.scopeModelStr == null ? 0 : getStringHashCode(this.scopeModelStr)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageProcessorCreate))
      return false;
    var tmp0_other_with_cast = other instanceof MessageProcessorCreate ? other : THROW_CCE();
    if (!(this.f4o_1 === tmp0_other_with_cast.f4o_1))
      return false;
    if (!(this.g4o_1 === tmp0_other_with_cast.g4o_1))
      return false;
    if (!(this.h4o_1 === tmp0_other_with_cast.h4o_1))
      return false;
    if (!(this.grammarStr === tmp0_other_with_cast.grammarStr))
      return false;
    if (!(this.scopeModelStr == tmp0_other_with_cast.scopeModelStr))
      return false;
    return true;
  }
}
class MessageProcessorCreateResponse extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, issues) {
    super('MessageProcessorCreateResponse');
    this.j4o_1 = languageId;
    this.k4o_1 = editorId;
    this.l4o_1 = sessionId;
    this.status = status;
    this.message = message;
    this.issues = issues;
  }
  e4o() {
    return this.j4o_1;
  }
  y4c() {
    return this.k4o_1;
  }
  k4n() {
    return this.l4o_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  w1b() {
    return this.issues;
  }
  ti() {
    return this.j4o_1;
  }
  ui() {
    return this.k4o_1;
  }
  r1j() {
    return this.l4o_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.issues;
  }
  n4o(languageId, editorId, sessionId, status, message, issues) {
    return new MessageProcessorCreateResponse(languageId, editorId, sessionId, status, message, issues);
  }
  copy(languageId, editorId, sessionId, status, message, issues, $super) {
    languageId = languageId === VOID ? this.j4o_1 : languageId;
    editorId = editorId === VOID ? this.k4o_1 : editorId;
    sessionId = sessionId === VOID ? this.l4o_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    issues = issues === VOID ? this.issues : issues;
    return this.n4o(languageId, editorId, sessionId, status, message, issues);
  }
  toString() {
    return 'MessageProcessorCreateResponse(languageId=' + this.j4o_1 + ', editorId=' + this.k4o_1 + ', sessionId=' + this.l4o_1 + ', status=' + this.status + ', message=' + this.message + ', issues=' + this.issues + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.j4o_1);
    result = imul(result, 31) + getStringHashCode(this.k4o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l4o_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + hashCode(this.issues) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageProcessorCreateResponse))
      return false;
    var tmp0_other_with_cast = other instanceof MessageProcessorCreateResponse ? other : THROW_CCE();
    if (!(this.j4o_1 === tmp0_other_with_cast.j4o_1))
      return false;
    if (!(this.k4o_1 === tmp0_other_with_cast.k4o_1))
      return false;
    if (!(this.l4o_1 === tmp0_other_with_cast.l4o_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.issues, tmp0_other_with_cast.issues))
      return false;
    return true;
  }
}
class MessageProcessorDelete extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId) {
    super('MessageProcessorDelete');
    this.o4o_1 = languageId;
    this.p4o_1 = editorId;
    this.q4o_1 = sessionId;
  }
  e4o() {
    return this.o4o_1;
  }
  y4c() {
    return this.p4o_1;
  }
  k4n() {
    return this.q4o_1;
  }
  ti() {
    return this.o4o_1;
  }
  ui() {
    return this.p4o_1;
  }
  r1j() {
    return this.q4o_1;
  }
  r4o(languageId, editorId, sessionId) {
    return new MessageProcessorDelete(languageId, editorId, sessionId);
  }
  copy(languageId, editorId, sessionId, $super) {
    languageId = languageId === VOID ? this.o4o_1 : languageId;
    editorId = editorId === VOID ? this.p4o_1 : editorId;
    sessionId = sessionId === VOID ? this.q4o_1 : sessionId;
    return this.r4o(languageId, editorId, sessionId);
  }
  toString() {
    return 'MessageProcessorDelete(languageId=' + this.o4o_1 + ', editorId=' + this.p4o_1 + ', sessionId=' + this.q4o_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.o4o_1);
    result = imul(result, 31) + getStringHashCode(this.p4o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q4o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageProcessorDelete))
      return false;
    var tmp0_other_with_cast = other instanceof MessageProcessorDelete ? other : THROW_CCE();
    if (!(this.o4o_1 === tmp0_other_with_cast.o4o_1))
      return false;
    if (!(this.p4o_1 === tmp0_other_with_cast.p4o_1))
      return false;
    if (!(this.q4o_1 === tmp0_other_with_cast.q4o_1))
      return false;
    return true;
  }
}
class MessageProcessorDeleteResponse extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message) {
    super('MessageProcessorDeleteResponse');
    this.s4o_1 = languageId;
    this.t4o_1 = editorId;
    this.u4o_1 = sessionId;
    this.status = status;
    this.message = message;
  }
  e4o() {
    return this.s4o_1;
  }
  y4c() {
    return this.t4o_1;
  }
  k4n() {
    return this.u4o_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  ti() {
    return this.s4o_1;
  }
  ui() {
    return this.t4o_1;
  }
  r1j() {
    return this.u4o_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  v4o(languageId, editorId, sessionId, status, message) {
    return new MessageProcessorDeleteResponse(languageId, editorId, sessionId, status, message);
  }
  copy(languageId, editorId, sessionId, status, message, $super) {
    languageId = languageId === VOID ? this.s4o_1 : languageId;
    editorId = editorId === VOID ? this.t4o_1 : editorId;
    sessionId = sessionId === VOID ? this.u4o_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    return this.v4o(languageId, editorId, sessionId, status, message);
  }
  toString() {
    return 'MessageProcessorDeleteResponse(languageId=' + this.s4o_1 + ', editorId=' + this.t4o_1 + ', sessionId=' + this.u4o_1 + ', status=' + this.status + ', message=' + this.message + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.s4o_1);
    result = imul(result, 31) + getStringHashCode(this.t4o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u4o_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageProcessorDeleteResponse))
      return false;
    var tmp0_other_with_cast = other instanceof MessageProcessorDeleteResponse ? other : THROW_CCE();
    if (!(this.s4o_1 === tmp0_other_with_cast.s4o_1))
      return false;
    if (!(this.t4o_1 === tmp0_other_with_cast.t4o_1))
      return false;
    if (!(this.u4o_1 === tmp0_other_with_cast.u4o_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    return true;
  }
}
class MessageSyntaxAnalyserConfigure extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, configuration) {
    super('MessageSyntaxAnalyserConfigure');
    this.w4o_1 = languageId;
    this.x4o_1 = editorId;
    this.y4o_1 = sessionId;
    this.configuration = configuration;
  }
  e4o() {
    return this.w4o_1;
  }
  y4c() {
    return this.x4o_1;
  }
  k4n() {
    return this.y4o_1;
  }
  o1z() {
    return this.configuration;
  }
  ti() {
    return this.w4o_1;
  }
  ui() {
    return this.x4o_1;
  }
  r1j() {
    return this.y4o_1;
  }
  s1j() {
    return this.configuration;
  }
  z4o(languageId, editorId, sessionId, configuration) {
    return new MessageSyntaxAnalyserConfigure(languageId, editorId, sessionId, configuration);
  }
  copy(languageId, editorId, sessionId, configuration, $super) {
    languageId = languageId === VOID ? this.w4o_1 : languageId;
    editorId = editorId === VOID ? this.x4o_1 : editorId;
    sessionId = sessionId === VOID ? this.y4o_1 : sessionId;
    configuration = configuration === VOID ? this.configuration : configuration;
    return this.z4o(languageId, editorId, sessionId, configuration);
  }
  toString() {
    return 'MessageSyntaxAnalyserConfigure(languageId=' + this.w4o_1 + ', editorId=' + this.x4o_1 + ', sessionId=' + this.y4o_1 + ', configuration=' + this.configuration + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.w4o_1);
    result = imul(result, 31) + getStringHashCode(this.x4o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y4o_1) | 0;
    result = imul(result, 31) + hashCode(this.configuration) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageSyntaxAnalyserConfigure))
      return false;
    var tmp0_other_with_cast = other instanceof MessageSyntaxAnalyserConfigure ? other : THROW_CCE();
    if (!(this.w4o_1 === tmp0_other_with_cast.w4o_1))
      return false;
    if (!(this.x4o_1 === tmp0_other_with_cast.x4o_1))
      return false;
    if (!(this.y4o_1 === tmp0_other_with_cast.y4o_1))
      return false;
    if (!equals(this.configuration, tmp0_other_with_cast.configuration))
      return false;
    return true;
  }
}
class MessageSyntaxAnalyserConfigureResponse extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, issues) {
    super('MessageSyntaxAnalyserConfigureResponse');
    this.a4p_1 = languageId;
    this.b4p_1 = editorId;
    this.c4p_1 = sessionId;
    this.status = status;
    this.message = message;
    this.issues = issues;
  }
  e4o() {
    return this.a4p_1;
  }
  y4c() {
    return this.b4p_1;
  }
  k4n() {
    return this.c4p_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  w1b() {
    return this.issues;
  }
  ti() {
    return this.a4p_1;
  }
  ui() {
    return this.b4p_1;
  }
  r1j() {
    return this.c4p_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.issues;
  }
  n4o(languageId, editorId, sessionId, status, message, issues) {
    return new MessageSyntaxAnalyserConfigureResponse(languageId, editorId, sessionId, status, message, issues);
  }
  copy(languageId, editorId, sessionId, status, message, issues, $super) {
    languageId = languageId === VOID ? this.a4p_1 : languageId;
    editorId = editorId === VOID ? this.b4p_1 : editorId;
    sessionId = sessionId === VOID ? this.c4p_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    issues = issues === VOID ? this.issues : issues;
    return this.n4o(languageId, editorId, sessionId, status, message, issues);
  }
  toString() {
    return 'MessageSyntaxAnalyserConfigureResponse(languageId=' + this.a4p_1 + ', editorId=' + this.b4p_1 + ', sessionId=' + this.c4p_1 + ', status=' + this.status + ', message=' + this.message + ', issues=' + this.issues + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a4p_1);
    result = imul(result, 31) + getStringHashCode(this.b4p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c4p_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + hashCode(this.issues) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageSyntaxAnalyserConfigureResponse))
      return false;
    var tmp0_other_with_cast = other instanceof MessageSyntaxAnalyserConfigureResponse ? other : THROW_CCE();
    if (!(this.a4p_1 === tmp0_other_with_cast.a4p_1))
      return false;
    if (!(this.b4p_1 === tmp0_other_with_cast.b4p_1))
      return false;
    if (!(this.c4p_1 === tmp0_other_with_cast.c4p_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.issues, tmp0_other_with_cast.issues))
      return false;
    return true;
  }
}
class MessageProcessRequest extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, goalRuleName, text, context) {
    super('MessageProcessRequest');
    this.d4p_1 = languageId;
    this.e4p_1 = editorId;
    this.f4p_1 = sessionId;
    this.goalRuleName = goalRuleName;
    this.text = text;
    this.context = context;
  }
  e4o() {
    return this.d4p_1;
  }
  y4c() {
    return this.e4p_1;
  }
  k4n() {
    return this.f4p_1;
  }
  n2l() {
    return this.goalRuleName;
  }
  u1p() {
    return this.text;
  }
  uf() {
    return this.context;
  }
  toString() {
    var tmp$ret$2;
    // Inline function 'kotlin.text.substring' call
    var tmp1_substring = this.text;
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.text.length;
    tmp$ret$0 = Math.min(10, tmp0_min);
    var tmp2_substring = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = tmp1_substring;
    tmp$ret$2 = tmp$ret$1.substring(0, tmp2_substring);
    return this.action + '(languageId=' + this.d4p_1 + ', editorId=' + this.e4p_1 + ', sessionId=' + this.f4p_1 + ', goalRuleName=' + this.goalRuleName + ', context=' + this.context + ", text='" + tmp$ret$2 + "')";
  }
  ti() {
    return this.d4p_1;
  }
  ui() {
    return this.e4p_1;
  }
  r1j() {
    return this.f4p_1;
  }
  s1j() {
    return this.goalRuleName;
  }
  t1j() {
    return this.text;
  }
  m4o() {
    return this.context;
  }
  g4p(languageId, editorId, sessionId, goalRuleName, text, context) {
    return new MessageProcessRequest(languageId, editorId, sessionId, goalRuleName, text, context);
  }
  copy(languageId, editorId, sessionId, goalRuleName, text, context, $super) {
    languageId = languageId === VOID ? this.d4p_1 : languageId;
    editorId = editorId === VOID ? this.e4p_1 : editorId;
    sessionId = sessionId === VOID ? this.f4p_1 : sessionId;
    goalRuleName = goalRuleName === VOID ? this.goalRuleName : goalRuleName;
    text = text === VOID ? this.text : text;
    context = context === VOID ? this.context : context;
    return this.g4p(languageId, editorId, sessionId, goalRuleName, text, context);
  }
  hashCode() {
    var result = getStringHashCode(this.d4p_1);
    result = imul(result, 31) + getStringHashCode(this.e4p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f4p_1) | 0;
    result = imul(result, 31) + (this.goalRuleName == null ? 0 : getStringHashCode(this.goalRuleName)) | 0;
    result = imul(result, 31) + getStringHashCode(this.text) | 0;
    result = imul(result, 31) + (this.context == null ? 0 : hashCode(this.context)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageProcessRequest))
      return false;
    var tmp0_other_with_cast = other instanceof MessageProcessRequest ? other : THROW_CCE();
    if (!(this.d4p_1 === tmp0_other_with_cast.d4p_1))
      return false;
    if (!(this.e4p_1 === tmp0_other_with_cast.e4p_1))
      return false;
    if (!(this.f4p_1 === tmp0_other_with_cast.f4p_1))
      return false;
    if (!(this.goalRuleName == tmp0_other_with_cast.goalRuleName))
      return false;
    if (!(this.text === tmp0_other_with_cast.text))
      return false;
    if (!equals(this.context, tmp0_other_with_cast.context))
      return false;
    return true;
  }
}
class MessageParseResult extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, issues, treeSerialised) {
    super('MessageParseResult');
    this.h4p_1 = languageId;
    this.i4p_1 = editorId;
    this.j4p_1 = sessionId;
    this.status = status;
    this.message = message;
    this.issues = issues;
    this.treeSerialised = treeSerialised;
  }
  e4o() {
    return this.h4p_1;
  }
  y4c() {
    return this.i4p_1;
  }
  k4n() {
    return this.j4p_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  w1b() {
    return this.issues;
  }
  k4p() {
    return this.treeSerialised;
  }
  toString() {
    return this.action + '(languageId=' + this.h4p_1 + ', editorId=' + this.i4p_1 + ', sessionId=' + this.j4p_1 + ', status=' + this.status + ', message=' + this.message + ', issues=' + this.issues + ", treeSerialised='...')";
  }
  ti() {
    return this.h4p_1;
  }
  ui() {
    return this.i4p_1;
  }
  r1j() {
    return this.j4p_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.issues;
  }
  l4p() {
    return this.treeSerialised;
  }
  m4p(languageId, editorId, sessionId, status, message, issues, treeSerialised) {
    return new MessageParseResult(languageId, editorId, sessionId, status, message, issues, treeSerialised);
  }
  copy(languageId, editorId, sessionId, status, message, issues, treeSerialised, $super) {
    languageId = languageId === VOID ? this.h4p_1 : languageId;
    editorId = editorId === VOID ? this.i4p_1 : editorId;
    sessionId = sessionId === VOID ? this.j4p_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    issues = issues === VOID ? this.issues : issues;
    treeSerialised = treeSerialised === VOID ? this.treeSerialised : treeSerialised;
    return this.m4p(languageId, editorId, sessionId, status, message, issues, treeSerialised);
  }
  hashCode() {
    var result = getStringHashCode(this.h4p_1);
    result = imul(result, 31) + getStringHashCode(this.i4p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j4p_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + hashCode(this.issues) | 0;
    result = imul(result, 31) + (this.treeSerialised == null ? 0 : getStringHashCode(this.treeSerialised)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageParseResult))
      return false;
    var tmp0_other_with_cast = other instanceof MessageParseResult ? other : THROW_CCE();
    if (!(this.h4p_1 === tmp0_other_with_cast.h4p_1))
      return false;
    if (!(this.i4p_1 === tmp0_other_with_cast.i4p_1))
      return false;
    if (!(this.j4p_1 === tmp0_other_with_cast.j4p_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.issues, tmp0_other_with_cast.issues))
      return false;
    if (!(this.treeSerialised == tmp0_other_with_cast.treeSerialised))
      return false;
    return true;
  }
}
class MessageSyntaxAnalysisResult extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, issues, asm) {
    super('MessageSyntaxAnalysisResult');
    this.n4p_1 = languageId;
    this.o4p_1 = editorId;
    this.p4p_1 = sessionId;
    this.status = status;
    this.message = message;
    this.issues = issues;
    this.asm = asm;
  }
  e4o() {
    return this.n4p_1;
  }
  y4c() {
    return this.o4p_1;
  }
  k4n() {
    return this.p4p_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  w1b() {
    return this.issues;
  }
  s1b() {
    return this.asm;
  }
  toString() {
    return this.action + '(languageId=' + this.n4p_1 + ', editorId=' + this.o4p_1 + ', sessionId=' + this.p4p_1 + ', status=' + this.status + ', message=' + this.message + ', issues=' + this.issues + ", asm='...')";
  }
  ti() {
    return this.n4p_1;
  }
  ui() {
    return this.o4p_1;
  }
  r1j() {
    return this.p4p_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.issues;
  }
  l4p() {
    return this.asm;
  }
  q4p(languageId, editorId, sessionId, status, message, issues, asm) {
    return new MessageSyntaxAnalysisResult(languageId, editorId, sessionId, status, message, issues, asm);
  }
  copy(languageId, editorId, sessionId, status, message, issues, asm, $super) {
    languageId = languageId === VOID ? this.n4p_1 : languageId;
    editorId = editorId === VOID ? this.o4p_1 : editorId;
    sessionId = sessionId === VOID ? this.p4p_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    issues = issues === VOID ? this.issues : issues;
    asm = asm === VOID ? this.asm : asm;
    return this.q4p(languageId, editorId, sessionId, status, message, issues, asm);
  }
  hashCode() {
    var result = getStringHashCode(this.n4p_1);
    result = imul(result, 31) + getStringHashCode(this.o4p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p4p_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + hashCode(this.issues) | 0;
    result = imul(result, 31) + (this.asm == null ? 0 : hashCode(this.asm)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageSyntaxAnalysisResult))
      return false;
    var tmp0_other_with_cast = other instanceof MessageSyntaxAnalysisResult ? other : THROW_CCE();
    if (!(this.n4p_1 === tmp0_other_with_cast.n4p_1))
      return false;
    if (!(this.o4p_1 === tmp0_other_with_cast.o4p_1))
      return false;
    if (!(this.p4p_1 === tmp0_other_with_cast.p4p_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.issues, tmp0_other_with_cast.issues))
      return false;
    if (!equals(this.asm, tmp0_other_with_cast.asm))
      return false;
    return true;
  }
}
class MessageSemanticAnalysisResult extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, issues, asm) {
    super('MessageSemanticAnalysisResult');
    this.r4p_1 = languageId;
    this.s4p_1 = editorId;
    this.t4p_1 = sessionId;
    this.status = status;
    this.message = message;
    this.issues = issues;
    this.asm = asm;
  }
  e4o() {
    return this.r4p_1;
  }
  y4c() {
    return this.s4p_1;
  }
  k4n() {
    return this.t4p_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  w1b() {
    return this.issues;
  }
  s1b() {
    return this.asm;
  }
  toString() {
    return this.action + '(languageId=' + this.r4p_1 + ', editorId=' + this.s4p_1 + ', sessionId=' + this.t4p_1 + ', status=' + this.status + ', message=' + this.message + ', issues=' + this.issues + ", asm='...'))";
  }
  ti() {
    return this.r4p_1;
  }
  ui() {
    return this.s4p_1;
  }
  r1j() {
    return this.t4p_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.issues;
  }
  l4p() {
    return this.asm;
  }
  q4p(languageId, editorId, sessionId, status, message, issues, asm) {
    return new MessageSemanticAnalysisResult(languageId, editorId, sessionId, status, message, issues, asm);
  }
  copy(languageId, editorId, sessionId, status, message, issues, asm, $super) {
    languageId = languageId === VOID ? this.r4p_1 : languageId;
    editorId = editorId === VOID ? this.s4p_1 : editorId;
    sessionId = sessionId === VOID ? this.t4p_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    issues = issues === VOID ? this.issues : issues;
    asm = asm === VOID ? this.asm : asm;
    return this.q4p(languageId, editorId, sessionId, status, message, issues, asm);
  }
  hashCode() {
    var result = getStringHashCode(this.r4p_1);
    result = imul(result, 31) + getStringHashCode(this.s4p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t4p_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + hashCode(this.issues) | 0;
    result = imul(result, 31) + (this.asm == null ? 0 : hashCode(this.asm)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageSemanticAnalysisResult))
      return false;
    var tmp0_other_with_cast = other instanceof MessageSemanticAnalysisResult ? other : THROW_CCE();
    if (!(this.r4p_1 === tmp0_other_with_cast.r4p_1))
      return false;
    if (!(this.s4p_1 === tmp0_other_with_cast.s4p_1))
      return false;
    if (!(this.t4p_1 === tmp0_other_with_cast.t4p_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.issues, tmp0_other_with_cast.issues))
      return false;
    if (!equals(this.asm, tmp0_other_with_cast.asm))
      return false;
    return true;
  }
}
class MessageParserInterruptRequest extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, reason) {
    super('MessageParserInterruptRequest');
    this.u4p_1 = languageId;
    this.v4p_1 = editorId;
    this.w4p_1 = sessionId;
    this.reason = reason;
  }
  e4o() {
    return this.u4p_1;
  }
  y4c() {
    return this.v4p_1;
  }
  k4n() {
    return this.w4p_1;
  }
  x4p() {
    return this.reason;
  }
  ti() {
    return this.u4p_1;
  }
  ui() {
    return this.v4p_1;
  }
  r1j() {
    return this.w4p_1;
  }
  s1j() {
    return this.reason;
  }
  y4p(languageId, editorId, sessionId, reason) {
    return new MessageParserInterruptRequest(languageId, editorId, sessionId, reason);
  }
  copy(languageId, editorId, sessionId, reason, $super) {
    languageId = languageId === VOID ? this.u4p_1 : languageId;
    editorId = editorId === VOID ? this.v4p_1 : editorId;
    sessionId = sessionId === VOID ? this.w4p_1 : sessionId;
    reason = reason === VOID ? this.reason : reason;
    return this.y4p(languageId, editorId, sessionId, reason);
  }
  toString() {
    return 'MessageParserInterruptRequest(languageId=' + this.u4p_1 + ', editorId=' + this.v4p_1 + ', sessionId=' + this.w4p_1 + ', reason=' + this.reason + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.u4p_1);
    result = imul(result, 31) + getStringHashCode(this.v4p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w4p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.reason) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageParserInterruptRequest))
      return false;
    var tmp0_other_with_cast = other instanceof MessageParserInterruptRequest ? other : THROW_CCE();
    if (!(this.u4p_1 === tmp0_other_with_cast.u4p_1))
      return false;
    if (!(this.v4p_1 === tmp0_other_with_cast.v4p_1))
      return false;
    if (!(this.w4p_1 === tmp0_other_with_cast.w4p_1))
      return false;
    if (!(this.reason === tmp0_other_with_cast.reason))
      return false;
    return true;
  }
}
class MessageLineTokens extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, lineTokens) {
    super('MessageLineTokens');
    this.z4p_1 = languageId;
    this.a4q_1 = editorId;
    this.b4q_1 = sessionId;
    this.status = status;
    this.message = message;
    this.lineTokens = lineTokens;
  }
  e4o() {
    return this.z4p_1;
  }
  y4c() {
    return this.a4q_1;
  }
  k4n() {
    return this.b4q_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  c4q() {
    return this.lineTokens;
  }
  toString() {
    return this.action + '(languageId=' + this.z4p_1 + ', editorId=' + this.a4q_1 + ', sessionId=' + this.b4q_1 + ', status=' + this.status + ', message=' + this.message + ", lineTokens='...'))";
  }
  ti() {
    return this.z4p_1;
  }
  ui() {
    return this.a4q_1;
  }
  r1j() {
    return this.b4q_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.lineTokens;
  }
  d4q(languageId, editorId, sessionId, status, message, lineTokens) {
    return new MessageLineTokens(languageId, editorId, sessionId, status, message, lineTokens);
  }
  copy(languageId, editorId, sessionId, status, message, lineTokens, $super) {
    languageId = languageId === VOID ? this.z4p_1 : languageId;
    editorId = editorId === VOID ? this.a4q_1 : editorId;
    sessionId = sessionId === VOID ? this.b4q_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    lineTokens = lineTokens === VOID ? this.lineTokens : lineTokens;
    return this.d4q(languageId, editorId, sessionId, status, message, lineTokens);
  }
  hashCode() {
    var result = getStringHashCode(this.z4p_1);
    result = imul(result, 31) + getStringHashCode(this.a4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b4q_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + hashCode(this.lineTokens) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageLineTokens))
      return false;
    var tmp0_other_with_cast = other instanceof MessageLineTokens ? other : THROW_CCE();
    if (!(this.z4p_1 === tmp0_other_with_cast.z4p_1))
      return false;
    if (!(this.a4q_1 === tmp0_other_with_cast.a4q_1))
      return false;
    if (!(this.b4q_1 === tmp0_other_with_cast.b4q_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.lineTokens, tmp0_other_with_cast.lineTokens))
      return false;
    return true;
  }
}
class MessageSetStyle extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, css) {
    super('MessageSetStyle');
    this.e4q_1 = languageId;
    this.f4q_1 = editorId;
    this.g4q_1 = sessionId;
    this.css = css;
  }
  e4o() {
    return this.e4q_1;
  }
  y4c() {
    return this.f4q_1;
  }
  k4n() {
    return this.g4q_1;
  }
  h4q() {
    return this.css;
  }
  toString() {
    return this.action + '(languageId=' + this.e4q_1 + ', editorId=' + this.f4q_1 + ', sessionId=' + this.g4q_1 + ", css='...')";
  }
  ti() {
    return this.e4q_1;
  }
  ui() {
    return this.f4q_1;
  }
  r1j() {
    return this.g4q_1;
  }
  s1j() {
    return this.css;
  }
  y4p(languageId, editorId, sessionId, css) {
    return new MessageSetStyle(languageId, editorId, sessionId, css);
  }
  copy(languageId, editorId, sessionId, css, $super) {
    languageId = languageId === VOID ? this.e4q_1 : languageId;
    editorId = editorId === VOID ? this.f4q_1 : editorId;
    sessionId = sessionId === VOID ? this.g4q_1 : sessionId;
    css = css === VOID ? this.css : css;
    return this.y4p(languageId, editorId, sessionId, css);
  }
  hashCode() {
    var result = getStringHashCode(this.e4q_1);
    result = imul(result, 31) + getStringHashCode(this.f4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.css) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageSetStyle))
      return false;
    var tmp0_other_with_cast = other instanceof MessageSetStyle ? other : THROW_CCE();
    if (!(this.e4q_1 === tmp0_other_with_cast.e4q_1))
      return false;
    if (!(this.f4q_1 === tmp0_other_with_cast.f4q_1))
      return false;
    if (!(this.g4q_1 === tmp0_other_with_cast.g4q_1))
      return false;
    if (!(this.css === tmp0_other_with_cast.css))
      return false;
    return true;
  }
}
class MessageSetStyleResult extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message) {
    super('MessageSetStyleResult');
    this.i4q_1 = languageId;
    this.j4q_1 = editorId;
    this.k4q_1 = sessionId;
    this.status = status;
    this.message = message;
  }
  e4o() {
    return this.i4q_1;
  }
  y4c() {
    return this.j4q_1;
  }
  k4n() {
    return this.k4q_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  ti() {
    return this.i4q_1;
  }
  ui() {
    return this.j4q_1;
  }
  r1j() {
    return this.k4q_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  v4o(languageId, editorId, sessionId, status, message) {
    return new MessageSetStyleResult(languageId, editorId, sessionId, status, message);
  }
  copy(languageId, editorId, sessionId, status, message, $super) {
    languageId = languageId === VOID ? this.i4q_1 : languageId;
    editorId = editorId === VOID ? this.j4q_1 : editorId;
    sessionId = sessionId === VOID ? this.k4q_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    return this.v4o(languageId, editorId, sessionId, status, message);
  }
  toString() {
    return 'MessageSetStyleResult(languageId=' + this.i4q_1 + ', editorId=' + this.j4q_1 + ', sessionId=' + this.k4q_1 + ', status=' + this.status + ', message=' + this.message + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.i4q_1);
    result = imul(result, 31) + getStringHashCode(this.j4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k4q_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageSetStyleResult))
      return false;
    var tmp0_other_with_cast = other instanceof MessageSetStyleResult ? other : THROW_CCE();
    if (!(this.i4q_1 === tmp0_other_with_cast.i4q_1))
      return false;
    if (!(this.j4q_1 === tmp0_other_with_cast.j4q_1))
      return false;
    if (!(this.k4q_1 === tmp0_other_with_cast.k4q_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    return true;
  }
}
class MessageCodeCompleteRequest extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, goalRuleName, text, position) {
    super('MessageCodeCompleteRequest');
    this.l4q_1 = languageId;
    this.m4q_1 = editorId;
    this.n4q_1 = sessionId;
    this.goalRuleName = goalRuleName;
    this.text = text;
    this.position = position;
  }
  e4o() {
    return this.l4q_1;
  }
  y4c() {
    return this.m4q_1;
  }
  k4n() {
    return this.n4q_1;
  }
  n2l() {
    return this.goalRuleName;
  }
  u1p() {
    return this.text;
  }
  t2j() {
    return this.position;
  }
  ti() {
    return this.l4q_1;
  }
  ui() {
    return this.m4q_1;
  }
  r1j() {
    return this.n4q_1;
  }
  s1j() {
    return this.goalRuleName;
  }
  t1j() {
    return this.text;
  }
  m4o() {
    return this.position;
  }
  o4q(languageId, editorId, sessionId, goalRuleName, text, position) {
    return new MessageCodeCompleteRequest(languageId, editorId, sessionId, goalRuleName, text, position);
  }
  copy(languageId, editorId, sessionId, goalRuleName, text, position, $super) {
    languageId = languageId === VOID ? this.l4q_1 : languageId;
    editorId = editorId === VOID ? this.m4q_1 : editorId;
    sessionId = sessionId === VOID ? this.n4q_1 : sessionId;
    goalRuleName = goalRuleName === VOID ? this.goalRuleName : goalRuleName;
    text = text === VOID ? this.text : text;
    position = position === VOID ? this.position : position;
    return this.o4q(languageId, editorId, sessionId, goalRuleName, text, position);
  }
  toString() {
    return 'MessageCodeCompleteRequest(languageId=' + this.l4q_1 + ', editorId=' + this.m4q_1 + ', sessionId=' + this.n4q_1 + ', goalRuleName=' + this.goalRuleName + ', text=' + this.text + ', position=' + this.position + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.l4q_1);
    result = imul(result, 31) + getStringHashCode(this.m4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n4q_1) | 0;
    result = imul(result, 31) + (this.goalRuleName == null ? 0 : getStringHashCode(this.goalRuleName)) | 0;
    result = imul(result, 31) + getStringHashCode(this.text) | 0;
    result = imul(result, 31) + this.position | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageCodeCompleteRequest))
      return false;
    var tmp0_other_with_cast = other instanceof MessageCodeCompleteRequest ? other : THROW_CCE();
    if (!(this.l4q_1 === tmp0_other_with_cast.l4q_1))
      return false;
    if (!(this.m4q_1 === tmp0_other_with_cast.m4q_1))
      return false;
    if (!(this.n4q_1 === tmp0_other_with_cast.n4q_1))
      return false;
    if (!(this.goalRuleName == tmp0_other_with_cast.goalRuleName))
      return false;
    if (!(this.text === tmp0_other_with_cast.text))
      return false;
    if (!(this.position === tmp0_other_with_cast.position))
      return false;
    return true;
  }
}
class MessageCodeCompleteResult extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, issues, completionItems) {
    super('MessageCodeCompleteResult');
    this.p4q_1 = languageId;
    this.q4q_1 = editorId;
    this.r4q_1 = sessionId;
    this.status = status;
    this.message = message;
    this.issues = issues;
    this.completionItems = completionItems;
  }
  e4o() {
    return this.p4q_1;
  }
  y4c() {
    return this.q4q_1;
  }
  k4n() {
    return this.r4q_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  w1b() {
    return this.issues;
  }
  s4q() {
    return this.completionItems;
  }
  ti() {
    return this.p4q_1;
  }
  ui() {
    return this.q4q_1;
  }
  r1j() {
    return this.r4q_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.issues;
  }
  l4p() {
    return this.completionItems;
  }
  t4q(languageId, editorId, sessionId, status, message, issues, completionItems) {
    return new MessageCodeCompleteResult(languageId, editorId, sessionId, status, message, issues, completionItems);
  }
  copy(languageId, editorId, sessionId, status, message, issues, completionItems, $super) {
    languageId = languageId === VOID ? this.p4q_1 : languageId;
    editorId = editorId === VOID ? this.q4q_1 : editorId;
    sessionId = sessionId === VOID ? this.r4q_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    issues = issues === VOID ? this.issues : issues;
    completionItems = completionItems === VOID ? this.completionItems : completionItems;
    return this.t4q(languageId, editorId, sessionId, status, message, issues, completionItems);
  }
  toString() {
    return 'MessageCodeCompleteResult(languageId=' + this.p4q_1 + ', editorId=' + this.q4q_1 + ', sessionId=' + this.r4q_1 + ', status=' + this.status + ', message=' + this.message + ', issues=' + this.issues + ', completionItems=' + this.completionItems + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.p4q_1);
    result = imul(result, 31) + getStringHashCode(this.q4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r4q_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + hashCode(this.issues) | 0;
    result = imul(result, 31) + (this.completionItems == null ? 0 : hashCode(this.completionItems)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageCodeCompleteResult))
      return false;
    var tmp0_other_with_cast = other instanceof MessageCodeCompleteResult ? other : THROW_CCE();
    if (!(this.p4q_1 === tmp0_other_with_cast.p4q_1))
      return false;
    if (!(this.q4q_1 === tmp0_other_with_cast.q4q_1))
      return false;
    if (!(this.r4q_1 === tmp0_other_with_cast.r4q_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.issues, tmp0_other_with_cast.issues))
      return false;
    if (!equals(this.completionItems, tmp0_other_with_cast.completionItems))
      return false;
    return true;
  }
}
class MessageGrammarAmbiguityAnalysisRequest extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId) {
    super('MessageGrammarAmbiguityAnalysisRequest');
    this.u4q_1 = languageId;
    this.v4q_1 = editorId;
    this.w4q_1 = sessionId;
  }
  e4o() {
    return this.u4q_1;
  }
  y4c() {
    return this.v4q_1;
  }
  k4n() {
    return this.w4q_1;
  }
  toString() {
    return this.action + '(languageId=' + this.u4q_1 + ', editorId=' + this.v4q_1 + ', sessionId=' + this.w4q_1 + ')';
  }
  ti() {
    return this.u4q_1;
  }
  ui() {
    return this.v4q_1;
  }
  r1j() {
    return this.w4q_1;
  }
  r4o(languageId, editorId, sessionId) {
    return new MessageGrammarAmbiguityAnalysisRequest(languageId, editorId, sessionId);
  }
  copy(languageId, editorId, sessionId, $super) {
    languageId = languageId === VOID ? this.u4q_1 : languageId;
    editorId = editorId === VOID ? this.v4q_1 : editorId;
    sessionId = sessionId === VOID ? this.w4q_1 : sessionId;
    return this.r4o(languageId, editorId, sessionId);
  }
  hashCode() {
    var result = getStringHashCode(this.u4q_1);
    result = imul(result, 31) + getStringHashCode(this.v4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w4q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageGrammarAmbiguityAnalysisRequest))
      return false;
    var tmp0_other_with_cast = other instanceof MessageGrammarAmbiguityAnalysisRequest ? other : THROW_CCE();
    if (!(this.u4q_1 === tmp0_other_with_cast.u4q_1))
      return false;
    if (!(this.v4q_1 === tmp0_other_with_cast.v4q_1))
      return false;
    if (!(this.w4q_1 === tmp0_other_with_cast.w4q_1))
      return false;
    return true;
  }
}
class MessageGrammarAmbiguityAnalysisResult extends AglWorkerMessage {
  constructor(languageId, editorId, sessionId, status, message, issues) {
    super('MessageGrammarAmbiguityAnalysisResult');
    this.x4q_1 = languageId;
    this.y4q_1 = editorId;
    this.z4q_1 = sessionId;
    this.status = status;
    this.message = message;
    this.issues = issues;
  }
  e4o() {
    return this.x4q_1;
  }
  y4c() {
    return this.y4q_1;
  }
  k4n() {
    return this.z4q_1;
  }
  m4d() {
    return this.status;
  }
  j9() {
    return this.message;
  }
  w1b() {
    return this.issues;
  }
  ti() {
    return this.x4q_1;
  }
  ui() {
    return this.y4q_1;
  }
  r1j() {
    return this.z4q_1;
  }
  s1j() {
    return this.status;
  }
  t1j() {
    return this.message;
  }
  m4o() {
    return this.issues;
  }
  a4r(languageId, editorId, sessionId, status, message, issues) {
    return new MessageGrammarAmbiguityAnalysisResult(languageId, editorId, sessionId, status, message, issues);
  }
  copy(languageId, editorId, sessionId, status, message, issues, $super) {
    languageId = languageId === VOID ? this.x4q_1 : languageId;
    editorId = editorId === VOID ? this.y4q_1 : editorId;
    sessionId = sessionId === VOID ? this.z4q_1 : sessionId;
    status = status === VOID ? this.status : status;
    message = message === VOID ? this.message : message;
    issues = issues === VOID ? this.issues : issues;
    return this.a4r(languageId, editorId, sessionId, status, message, issues);
  }
  toString() {
    return 'MessageGrammarAmbiguityAnalysisResult(languageId=' + this.x4q_1 + ', editorId=' + this.y4q_1 + ', sessionId=' + this.z4q_1 + ', status=' + this.status + ', message=' + this.message + ', issues=' + this.issues + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x4q_1);
    result = imul(result, 31) + getStringHashCode(this.y4q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z4q_1) | 0;
    result = imul(result, 31) + this.status.hashCode() | 0;
    result = imul(result, 31) + (this.message == null ? 0 : getStringHashCode(this.message)) | 0;
    result = imul(result, 31) + hashCode(this.issues) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageGrammarAmbiguityAnalysisResult))
      return false;
    var tmp0_other_with_cast = other instanceof MessageGrammarAmbiguityAnalysisResult ? other : THROW_CCE();
    if (!(this.x4q_1 === tmp0_other_with_cast.x4q_1))
      return false;
    if (!(this.y4q_1 === tmp0_other_with_cast.y4q_1))
      return false;
    if (!(this.z4q_1 === tmp0_other_with_cast.z4q_1))
      return false;
    if (!this.status.equals(tmp0_other_with_cast.status))
      return false;
    if (!(this.message == tmp0_other_with_cast.message))
      return false;
    if (!equals(this.issues, tmp0_other_with_cast.issues))
      return false;
    return true;
  }
}
class AglEditorJsAbstract extends AglEditorAbstract {
  constructor(languageId, editorId, logFunction, worker) {
    super(languageId, editorId, logFunction);
    this.aglWorker = new AglWorkerClient(this.agl, worker);
  }
  h4r(_set____db54di) {
    this.aglWorker = _set____db54di;
  }
  i4r() {
    return this.aglWorker;
  }
  j4r(_set____db54di) {
    this.g4r_1 = _set____db54di;
  }
  k4r() {
    var tmp = this.g4r_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('workerTokenizer');
    }
  }
  connectWorker(workerTokenizer) {
    this.g4r_1 = workerTokenizer;
    this.aglWorker.initialise();
    var tmp = this.aglWorker;
    tmp.setStyleResult = AglEditorJsAbstract$connectWorker$lambda(this);
    var tmp_0 = this.aglWorker;
    tmp_0.processorCreateResult = AglEditorJsAbstract$processorCreateResult$ref(this);
    var tmp_1 = this.aglWorker;
    tmp_1.syntaxAnalyserConfigureResult = AglEditorJsAbstract$syntaxAnalyserConfigureResult$ref(this);
    var tmp_2 = this.aglWorker;
    tmp_2.parseResult = AglEditorJsAbstract$parseResult$ref(this);
    var tmp_3 = this.aglWorker;
    tmp_3.lineTokens = AglEditorJsAbstract$lineTokens$ref(this);
    var tmp_4 = this.aglWorker;
    tmp_4.syntaxAnalysisResult = AglEditorJsAbstract$syntaxAnalysisResult$ref(this);
    var tmp_5 = this.aglWorker;
    tmp_5.semanticAnalysisResult = AglEditorJsAbstract$semanticAnalysisResult$ref(this);
  }
  updateProcessor() {
    var grammarStr = this.agl.languageDefinition.grammarStr;
    var tmp$ret$0;
    // Inline function 'kotlin.text.isNullOrBlank' call
    // Inline function 'kotlin.contracts.contract' call
    tmp$ret$0 = grammarStr == null ? true : isBlank(grammarStr);
    if (tmp$ret$0) {
    } else {
      this.clearErrorMarkers();
      this.aglWorker.createProcessor(this.languageIdentity, this.editorId, this.sessionId, grammarStr, this.agl.languageDefinition.scopeModelStr);
      this.workerTokenizer.reset();
      this.resetTokenization();
    }
  }
  get workerTokenizer() {
    return this.k4r();
  }
  set workerTokenizer(value) {
    this.j4r(value);
  }
  get baseEditor() {
    return this.x4c();
  }
  get text() {
    return this.u1p();
  }
  set text(value) {
    this.g4d(value);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
  }
  terminateSharedWorker(workerScriptName) {
    var tmp$ret$6;
    // Inline function 'org.w3c.dom.WorkerOptions' call
    var tmp$ret$2;
    // Inline function 'org.w3c.dom.MODULE' call
    var tmp0_get_MODULE_re4apj = null;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = 'module';
    var tmp0_unsafeCast = tmp$ret$0;
    tmp$ret$1 = tmp0_unsafeCast;
    tmp$ret$2 = tmp$ret$1;
    var tmp2_WorkerOptions = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'org.w3c.fetch.OMIT' call
    var tmp1_get_OMIT_ju129n = null;
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = 'omit';
    var tmp0_unsafeCast_0 = tmp$ret$3;
    tmp$ret$4 = tmp0_unsafeCast_0;
    tmp$ret$5 = tmp$ret$4;
    var tmp3_WorkerOptions = tmp$ret$5;
    var o = {};
    o['type'] = tmp2_WorkerOptions;
    o['credentials'] = tmp3_WorkerOptions;
    tmp$ret$6 = o;
    var w = new SharedWorker(workerScriptName, VOID, tmp$ret$6);
    w.port.close();
  }
}
class AglWorkerClient {
  constructor(agl, worker) {
    Companion_getInstance_1();
    this.agl = agl;
    this.worker = worker;
    var tmp = this;
    var tmp_0 = this.worker;
    tmp.sharedWorker = tmp_0 instanceof SharedWorker;
    var tmp_1 = this;
    tmp_1.setStyleResult = AglWorkerClient$setStyleResult$lambda;
    var tmp_2 = this;
    tmp_2.processorCreateResult = AglWorkerClient$processorCreateResult$lambda;
    var tmp_3 = this;
    tmp_3.syntaxAnalyserConfigureResult = AglWorkerClient$syntaxAnalyserConfigureResult$lambda;
    var tmp_4 = this;
    tmp_4.parseResult = AglWorkerClient$parseResult$lambda;
    var tmp_5 = this;
    tmp_5.lineTokens = AglWorkerClient$lineTokens$lambda;
    var tmp_6 = this;
    tmp_6.syntaxAnalysisResult = AglWorkerClient$syntaxAnalysisResult$lambda;
    var tmp_7 = this;
    tmp_7.semanticAnalysisResult = AglWorkerClient$semanticAnalysisResult$lambda;
    var tmp_8 = this;
    tmp_8.codeCompleteResult = AglWorkerClient$codeCompleteResult$lambda;
  }
  c25() {
    return this.agl;
  }
  l4r() {
    return this.worker;
  }
  m4r() {
    return this.sharedWorker;
  }
  n4r(_set____db54di) {
    this.setStyleResult = _set____db54di;
  }
  o4r() {
    return this.setStyleResult;
  }
  p4r(_set____db54di) {
    this.processorCreateResult = _set____db54di;
  }
  q4r() {
    return this.processorCreateResult;
  }
  r4r(_set____db54di) {
    this.syntaxAnalyserConfigureResult = _set____db54di;
  }
  s4r() {
    return this.syntaxAnalyserConfigureResult;
  }
  t4r(_set____db54di) {
    this.parseResult = _set____db54di;
  }
  u4r() {
    return this.parseResult;
  }
  v4r(_set____db54di) {
    this.lineTokens = _set____db54di;
  }
  c4q() {
    return this.lineTokens;
  }
  w4r(_set____db54di) {
    this.syntaxAnalysisResult = _set____db54di;
  }
  x4r() {
    return this.syntaxAnalysisResult;
  }
  y4r(_set____db54di) {
    this.semanticAnalysisResult = _set____db54di;
  }
  z4r() {
    return this.semanticAnalysisResult;
  }
  a4s(_set____db54di) {
    this.codeCompleteResult = _set____db54di;
  }
  b4s() {
    return this.codeCompleteResult;
  }
  initialise() {
    this.worker.onerror = AglWorkerClient$initialise$lambda(this);
    var tmp;
    if (this.sharedWorker) {
      var tmp_0 = this.worker;
      tmp = (tmp_0 instanceof SharedWorker ? tmp_0 : THROW_CCE()).port;
    } else {
      var tmp_1 = this.worker;
      tmp = tmp_1 instanceof Worker ? tmp_1 : THROW_CCE();
    }
    var tgt = tmp;
    var tmp_2 = AglWorkerClient$initialise$lambda_0(this);
    var tmp$ret$1;
    // Inline function 'net.akehurst.language.editor.common.objectJS' call
    var o = {};
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.editor.common.AglWorkerClient.initialise.<anonymous>' call
    tmp$ret$0 = Unit_getInstance();
    tmp$ret$1 = o;
    tgt.addEventListener('message', tmp_2, tmp$ret$1);
    if (this.sharedWorker) {
      var tmp_3 = this.worker;
      (tmp_3 instanceof SharedWorker ? tmp_3 : THROW_CCE()).port.start();
    } else {
      var tmp_4 = this.worker;
      if (tmp_4 instanceof Worker)
        tmp_4;
      else
        THROW_CCE();
    }
  }
  c4s(msg, transferables) {
    this.agl.logger.log(LogLevel_Trace_getInstance(), 'Sending message: ' + msg, null);
    var str = AglWorkerSerialisation_getInstance().serialise(msg);
    if (this.sharedWorker) {
      var tmp = this.worker;
      (tmp instanceof SharedWorker ? tmp : THROW_CCE()).port.postMessage(str, transferables);
    } else {
      var tmp_0 = this.worker;
      (tmp_0 instanceof Worker ? tmp_0 : THROW_CCE()).postMessage(str, transferables);
    }
  }
  sendToWorker(msg, transferables, $super) {
    var tmp;
    if (transferables === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.emptyArray' call
      tmp$ret$0 = [];
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = transferables;
    }
    transferables = tmp;
    return this.c4s(msg, transferables);
  }
  createProcessor(languageId, editorId, sessionId, grammarStr, scopeModelStr) {
    this.sendToWorker(new MessageProcessorCreate(languageId, editorId, sessionId, grammarStr, scopeModelStr));
  }
  configureSyntaxAnalyser(languageId, editorId, sessionId, configuration) {
    this.sendToWorker(new MessageSyntaxAnalyserConfigure(languageId, editorId, sessionId, configuration));
  }
  interrupt(languageId, editorId, sessionId) {
    this.sendToWorker(new MessageParserInterruptRequest(languageId, editorId, sessionId, 'New parse request'));
  }
  processSentence(languageId, editorId, sessionId, goalRuleName, sentence, context) {
    this.sendToWorker(new MessageProcessRequest(languageId, editorId, sessionId, goalRuleName, sentence, context));
  }
  setStyle(languageId, editorId, sessionId, css) {
    this.sendToWorker(new MessageSetStyle(languageId, editorId, sessionId, css));
  }
  getCompletionItems() {
  }
  static get Companion() {
    return Companion_getInstance_1();
  }
}
//endregion
var BuildConfig_instance;
function BuildConfig_getInstance() {
  if (BuildConfig_instance === VOID)
    new BuildConfig_0();
  return BuildConfig_instance;
}
function MessageStatus$values$ref() {
  var l = function () {
    return values_7();
  };
  l.callableName = 'values';
  return l;
}
function ParseAction$values$ref() {
  var l = function () {
    return values();
  };
  l.callableName = 'values';
  return l;
}
function AutomatonKind$values$ref() {
  var l = function () {
    return values_0();
  };
  l.callableName = 'values';
  return l;
}
function CompletionItemKind$values$ref() {
  var l = function () {
    return values_1();
  };
  l.callableName = 'values';
  return l;
}
function LanguageIssueKind$values$ref() {
  var l = function () {
    return values_2();
  };
  l.callableName = 'values';
  return l;
}
function LanguageProcessorPhase$values$ref() {
  var l = function () {
    return values_3();
  };
  l.callableName = 'values';
  return l;
}
function AglStyleSelectorKind$values$ref() {
  var l = function () {
    return values_4();
  };
  l.callableName = 'values';
  return l;
}
function OverrideKind$values$ref() {
  var l = function () {
    return values_5();
  };
  l.callableName = 'values';
  return l;
}
function SeparatedListKind$values$ref() {
  var l = function () {
    return values_6();
  };
  l.callableName = 'values';
  return l;
}
var KotlinxReflectForModule_instance;
function KotlinxReflectForModule_getInstance() {
  if (KotlinxReflectForModule_instance === VOID)
    new KotlinxReflectForModule_0();
  return KotlinxReflectForModule_instance;
}
function AglEditorAbstract$lambda(this$0) {
  return function (_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd) {
    this$0.updateProcessor();
    this$0.updateStyle();
    return Unit_getInstance();
  };
}
function AglEditorAbstract$lambda_0(this$0) {
  return function (_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd) {
    this$0.updateProcessor();
    this$0.updateStyle();
    return Unit_getInstance();
  };
}
function AglEditorAbstract$lambda_1(this$0) {
  return function (_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd) {
    this$0.updateStyle();
    return Unit_getInstance();
  };
}
function logAll($this, lvl, msg, t) {
  var tmp;
  switch (lvl.bc_1) {
    case 1:
      tmp = AglLoggerToConsole$logFatal$ref($this);
      break;
    case 2:
      tmp = AglLoggerToConsole$logError$ref($this);
      break;
    case 3:
      tmp = AglLoggerToConsole$logWarn$ref($this);
      break;
    case 4:
      tmp = AglLoggerToConsole$logInfo$ref($this);
      break;
    case 5:
      tmp = AglLoggerToConsole$logDebug$ref($this);
      break;
    case 6:
      tmp = AglLoggerToConsole$logTrace$ref($this);
      break;
    default:
      var tmp0_error = "Internal Error: cannot log a message to '" + lvl + "'";
      throw IllegalStateException.y1(toString(tmp0_error));
  }
  var func = tmp;
  if (null == t) {
    func(msg);
  } else {
    func(msg);
    printStackTrace(t);
  }
}
function AglLoggerToConsole$logFatal$ref($boundThis) {
  var l = function (p0) {
    $boundThis.logFatal(p0);
    return Unit_getInstance();
  };
  l.callableName = 'logFatal';
  return l;
}
function AglLoggerToConsole$logError$ref($boundThis) {
  var l = function (p0) {
    $boundThis.logError(p0);
    return Unit_getInstance();
  };
  l.callableName = 'logError';
  return l;
}
function AglLoggerToConsole$logWarn$ref($boundThis) {
  var l = function (p0) {
    $boundThis.logWarn(p0);
    return Unit_getInstance();
  };
  l.callableName = 'logWarn';
  return l;
}
function AglLoggerToConsole$logInfo$ref($boundThis) {
  var l = function (p0) {
    $boundThis.logInfo(p0);
    return Unit_getInstance();
  };
  l.callableName = 'logInfo';
  return l;
}
function AglLoggerToConsole$logDebug$ref($boundThis) {
  var l = function (p0) {
    $boundThis.logDebug(p0);
    return Unit_getInstance();
  };
  l.callableName = 'logDebug';
  return l;
}
function AglLoggerToConsole$logTrace$ref($boundThis) {
  var l = function (p0) {
    $boundThis.logTrace(p0);
    return Unit_getInstance();
  };
  l.callableName = 'logTrace';
  return l;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function mapTokenTypeToClass($this, tokenType) {
  var cssClass = $this.o4n_1.u3(tokenType);
  return cssClass;
}
function mapToCssClasses($this, leaf) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_mapNotNull = leaf.metaTags;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var tmp0_mapNotNullTo = ArrayList.i4();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = tmp0_mapNotNull.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'net.akehurst.language.editor.common.AglStyleHandler.mapToCssClasses.<anonymous>' call
    var tmp0_safe_receiver = mapTokenTypeToClass($this, element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
    }
  }
  var metaTagClasses = tmp0_mapNotNullTo;
  var tmp;
  if (!leaf.tagList.y()) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp1_mapNotNull = leaf.tagList;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo_0 = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = tmp1_mapNotNull.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'net.akehurst.language.editor.common.AglStyleHandler.mapToCssClasses.<anonymous>' call
      var tmp0_safe_receiver_0 = mapTokenTypeToClass($this, element_0);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo_0.e1(tmp0_safe_receiver_0);
      }
    }
    tmp = tmp0_mapNotNullTo_0;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp2_mapNotNull = listOf(mapTokenTypeToClass($this, leaf.name));
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo_1 = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = tmp2_mapNotNull.u();
    while (tmp0_iterator_1.h1()) {
      var element_1 = tmp0_iterator_1.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'net.akehurst.language.editor.common.AglStyleHandler.mapToCssClasses.<anonymous>' call
      if (element_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo_1.e1(element_1);
      }
    }
    tmp = tmp0_mapNotNullTo_1;
  }
  var otherClasses = tmp;
  var classes = plus(metaTagClasses, otherClasses);
  var tmp_0;
  if (classes.y()) {
    tmp_0 = listOf('nostyle');
  } else {
    tmp_0 = toList(toSet(classes));
  }
  return tmp_0;
}
function mapTokenTypeToClass_0($this, tokenType) {
  var cssClass = $this.agl.styleHandler.mapClass(tokenType);
  return cssClass;
}
function mapToCssClasses_0($this, leaf) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = leaf.metaTags;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.editor.common.AglTokenizer.mapToCssClasses.<anonymous>' call
    tmp$ret$0 = mapTokenTypeToClass_0($this, item);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var metaTagClasses = tmp0_mapTo;
  var tmp;
  if (!leaf.tagList.y()) {
    // Inline function 'kotlin.collections.map' call
    var tmp1_map = leaf.tagList;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
    var tmp0_iterator_0 = tmp1_map.u();
    while (tmp0_iterator_0.h1()) {
      var item_0 = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.editor.common.AglTokenizer.mapToCssClasses.<anonymous>' call
      tmp$ret$3 = mapTokenTypeToClass_0($this, item_0);
      tmp0_mapTo_0.e1(tmp$ret$3);
    }
    tmp = tmp0_mapTo_0;
  } else {
    // Inline function 'kotlin.collections.map' call
    var tmp2_map = listOf(mapTokenTypeToClass_0($this, leaf.name));
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(tmp2_map, 10));
    var tmp0_iterator_1 = tmp2_map.u();
    while (tmp0_iterator_1.h1()) {
      var item_1 = tmp0_iterator_1.j1();
      // Inline function 'net.akehurst.language.editor.common.AglTokenizer.mapToCssClasses.<anonymous>' call
      tmp0_mapTo_1.e1(item_1);
    }
    tmp = tmp0_mapTo_1;
  }
  var otherClasses = tmp;
  var classes = plus(metaTagClasses, otherClasses);
  var tmp_0;
  if (classes.y()) {
    tmp_0 = listOf('nostyle');
  } else {
    tmp_0 = toList(toSet(classes));
  }
  return tmp_0;
}
function initialise($this) {
  if (!$this.y4n_1) {
    KotlinxReflectForModule_getInstance().y4m();
    initialiseApiTypes($this);
    initialiseTypeModel($this);
    initialiseStyleAsm($this);
    initialiseScopesAsm($this);
    initialiseGrammarAsm($this);
    initialiseMessages($this);
    initialiseAsmSimple($this);
    initialiseSPPT($this);
    $this.z4n_1.registry.resolveImports();
    $this.y4n_1 = true;
  }
}
function initialiseApiTypes($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('ApiType', false, VOID, AglWorkerSerialisation$initialiseApiTypes$lambda));
}
function initialiseTypeModel($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('TypeModel', false, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda));
}
function initialiseStyleAsm($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('StyleAsm', false, VOID, AglWorkerSerialisation$initialiseStyleAsm$lambda));
}
function initialiseScopesAsm($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('ScopesAsm', false, VOID, AglWorkerSerialisation$initialiseScopesAsm$lambda));
}
function initialiseMessages($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('Messages', false, VOID, AglWorkerSerialisation$initialiseMessages$lambda));
}
function initialiseAsmSimple($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('AsmSimple', false, VOID, AglWorkerSerialisation$initialiseAsmSimple$lambda));
}
function initialiseGrammarAsm($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('GrammarAsm', false, VOID, AglWorkerSerialisation$initialiseGrammarAsm$lambda));
}
function initialiseSPPT($this) {
  $this.z4n_1.confgureFromKompositeModel(typeModel('SPPT', false, VOID, AglWorkerSerialisation$initialiseSPPT$lambda));
}
function AglWorkerSerialisation$initialiseApiTypes$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.editor.common', tmp, AglWorkerSerialisation$initialiseApiTypes$lambda$lambda);
  var tmp_0 = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.api.parser', tmp_0, AglWorkerSerialisation$initialiseApiTypes$lambda$lambda_0);
  var tmp_1 = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.api.processor', tmp_1, AglWorkerSerialisation$initialiseApiTypes$lambda$lambda_1);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseApiTypes$lambda$lambda($this$namespace) {
  $this$namespace.dataType('AglToken', AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'styles', 'Array', listOf('String'));
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'value', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'line', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'column', 'Int');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseApiTypes$lambda$lambda_0($this$namespace) {
  $this$namespace.dataType('InputLocation', AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda_0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda_0($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'position', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'column', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'line', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'length', 'Int');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseApiTypes$lambda$lambda_1($this$namespace) {
  $this$namespace.enumType('LanguageIssueKind', emptyList());
  $this$namespace.enumType('LanguageProcessorPhase', emptyList());
  $this$namespace.dataType('LanguageIssue', AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda_1);
  $this$namespace.dataType('CompletionItem', AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda_2);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda_1($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'kind', 'LanguageIssueKind');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'phase', 'LanguageProcessorPhase');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'location', 'InputLocation');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'data', 'Any');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseApiTypes$lambda$lambda$lambda_2($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'ruleName', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'text', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections', 'net.akehurst.language.agl.grammarTypeModel']);
  $this$typeModel.namespace('net.akehurst.language.agl.default', tmp, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda);
  var tmp_0 = mutableListOf(['kotlin', 'kotlin.collections', 'net.akehurst.language.typemodel.simple']);
  $this$typeModel.namespace('net.akehurst.language.agl.grammarTypeModel', tmp_0, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda_0);
  var tmp_1 = mutableListOf(['kotlin', 'kotlin.collections', 'net.akehurst.language.api.typemodel']);
  $this$typeModel.namespace('net.akehurst.language.typemodel.simple', tmp_1, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda_1);
  var tmp_2 = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.api.typemodel', tmp_2, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda_2);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda($this$namespace) {
  $this$namespace.dataType('GrammarTypeNamespaceFromGrammar', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda($this$dataType) {
  $this$dataType.xo(['GrammarTypeNamespaceAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda_0($this$namespace) {
  $this$namespace.dataType('GrammarTypeNamespaceSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_0);
  $this$namespace.dataType('GrammarTypeNamespaceAbstract', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_1);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_0($this$dataType) {
  $this$dataType.xo(['GrammarTypeNamespaceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'qualifiedName', 'String');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'imports', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_1($this$dataType) {
  $this$dataType.xo(['TypeNamespaceAbstract']);
  var tmp = setOf([$this$dataType.dp_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'allRuleNameToType', 'Map', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_0($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  $this$propertyOf.typeArgument('TypeInstance');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda_1($this$namespace) {
  $this$namespace.dataType('SimpleTypeModelStdLib', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_2);
  $this$namespace.dataType('TypeModelSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_3);
  $this$namespace.dataType('TypeModelAbstract', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_4);
  $this$namespace.dataType('TypeInstanceAbstract', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_5);
  $this$namespace.dataType('TypeInstanceSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_6);
  $this$namespace.dataType('TupleTypeInstance', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_7);
  $this$namespace.dataType('UnnamedSuperTypeTypeInstance', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_8);
  $this$namespace.dataType('TypeNamespaceAbstract', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_9);
  $this$namespace.dataType('TypeNamespaceSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_10);
  $this$namespace.dataType('TypeDefinitionSimpleAbstract', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_11);
  $this$namespace.dataType('SpecialTypeSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_12);
  $this$namespace.dataType('PrimitiveTypeSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_13);
  $this$namespace.dataType('EnumTypeSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_14);
  $this$namespace.dataType('UnnamedSuperTypeTypeSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_15);
  $this$namespace.dataType('StructuredTypeSimpleAbstract', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_16);
  $this$namespace.dataType('TupleTypeSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_17);
  $this$namespace.dataType('DataTypeSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_18);
  $this$namespace.dataType('CollectionTypeSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_19);
  $this$namespace.dataType('PropertyDeclarationSimple', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_20);
  var tmp$ret$0;
  // Inline function 'kotlin.collections.listOf' call
  tmp$ret$0 = emptyList();
  $this$namespace.enumType('PropertyCharacteristic', tmp$ret$0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_2($this$dataType) {
  $this$dataType.xo(['TypeNamespaceAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_3($this$dataType) {
  $this$dataType.xo(['TypeModelAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_4($this$dataType) {
  $this$dataType.xo(['TypeModel']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  var tmp = setOf([$this$dataType.dp_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'namespace', 'Map', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_1);
  var tmp_0 = setOf([$this$dataType.dp_1, $this$dataType.bp_1]);
  $this$dataType.gp(tmp_0, 'allNamespace', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_2);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_1($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  $this$propertyOf.typeArgument('TypeNamespace');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_2($this$propertyOf) {
  $this$propertyOf.typeArgument('TypeNamespace');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_5($this$dataType) {
  $this$dataType.xo(['TypeInstance']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_6($this$dataType) {
  $this$dataType.xo(['TypeInstanceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'qualifiedOrImportedTypeName', 'String');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'typeArguments', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_3);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isNullable', 'Boolean');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_3($this$propertyOf) {
  $this$propertyOf.typeArgument('TypeInstance');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_7($this$dataType) {
  $this$dataType.xo(['TypeInstanceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'type', 'TupleType');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'typeArguments', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_4);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isNullable', 'Boolean');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_4($this$propertyOf) {
  $this$propertyOf.typeArgument('TypeInstance');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_8($this$dataType) {
  $this$dataType.xo(['TypeInstanceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'type', 'UnnamedSuperTypeType');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'typeArguments', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_5);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isNullable', 'Boolean');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_5($this$propertyOf) {
  $this$propertyOf.typeArgument('TypeInstance');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_9($this$dataType) {
  $this$dataType.xo(['TypeNamespace']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'qualifiedName', 'String');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'imports', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_6);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_6($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_10($this$dataType) {
  $this$dataType.xo(['TypeNamespaceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'qualifiedName', 'String');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'imports', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_7);
  var tmp_0 = setOf([$this$dataType.dp_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp_0, 'allTypesByName', 'Map', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_8);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_7($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_8($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  $this$propertyOf.typeArgument('TypeDefinition');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_11($this$dataType) {
  $this$dataType.xo(['TypeDefinition']);
  var tmp = setOf([$this$dataType.dp_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'typeParameters', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_9);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_9($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_12($this$dataType) {
  $this$dataType.xo(['TypeDefinitionSimpleAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_13($this$dataType) {
  $this$dataType.xo(['TypeDefinitionSimpleAbstract', 'PrimitiveType']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_14($this$dataType) {
  $this$dataType.xo(['TypeDefinitionSimpleAbstract', 'EnumType']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'literals', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_10);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_10($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_15($this$dataType) {
  $this$dataType.xo(['TypeDefinitionSimpleAbstract', 'UnnamedSuperTypeType']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'id', 'Int');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'subtypes', 'List', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_11);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_11($this$propertyOf) {
  $this$propertyOf.typeArgument('TypeInstance');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_16($this$dataType) {
  $this$dataType.xo(['TypeDefinitionSimpleAbstract', 'StructuredType']);
  var tmp = setOf([$this$dataType.dp_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'properties', 'Map', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_12);
  var tmp_0 = setOf([$this$dataType.dp_1, $this$dataType.bp_1]);
  $this$dataType.gp(tmp_0, 'property', 'Map', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_13);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_12($this$propertyOf) {
  $this$propertyOf.typeArgument('Int');
  $this$propertyOf.typeArgument('PropertyDeclaration');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_13($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  $this$propertyOf.typeArgument('PropertyDeclaration');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_17($this$dataType) {
  $this$dataType.xo(['StructuredTypeSimpleAbstract', 'TupleType']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_18($this$dataType) {
  $this$dataType.xo(['StructuredTypeSimpleAbstract', 'DataType']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.bp_1]), 'supertypes', 'List', listOf('DataType'));
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.bp_1]), 'subtypes', 'List', listOf('DataType'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_19($this$dataType) {
  $this$dataType.xo(['StructuredTypeSimpleAbstract', 'CollectionType']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'namespace', 'TypeNamespace');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'typeParameters', 'String');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.bp_1]), 'supertypes', 'List', listOf('CollectionType'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_20($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'owner', 'StructuredType');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'typeInstance', 'TypeInstance');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'characteristics', 'Set', VOID, VOID, AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_14);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'index', 'Int');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda$lambda_14($this$propertyOf) {
  $this$propertyOf.typeArgument('PropertyCharacteristic');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda_2($this$namespace) {
  $this$namespace.dataType('TypeModel', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_21);
  $this$namespace.dataType('TypeNamespace', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_22);
  $this$namespace.dataType('TypeInstance', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_23);
  $this$namespace.dataType('TypeDefinition', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_24);
  $this$namespace.dataType('PrimitiveType', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_25);
  $this$namespace.dataType('EnumType', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_26);
  $this$namespace.dataType('StructuredType', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_27);
  $this$namespace.dataType('TupleType', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_28);
  $this$namespace.dataType('DataType', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_29);
  $this$namespace.dataType('PropertyDeclaration', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_30);
  var tmp$ret$0;
  // Inline function 'kotlin.collections.listOf' call
  tmp$ret$0 = emptyList();
  $this$namespace.enumType('PropertyCharacteristic', tmp$ret$0);
  $this$namespace.dataType('UnnamedSuperTypeType', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_31);
  $this$namespace.dataType('CollectionType', AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_32);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_21($this$dataType) {
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_22($this$dataType) {
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_23($this$dataType) {
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_24($this$dataType) {
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_25($this$dataType) {
  $this$dataType.xo(['TypeDefinition']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_26($this$dataType) {
  $this$dataType.xo(['TypeDefinition']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_27($this$dataType) {
  $this$dataType.xo(['TypeDefinition']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_28($this$dataType) {
  $this$dataType.xo(['StructuredType']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_29($this$dataType) {
  $this$dataType.xo(['StructuredType']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_30($this$dataType) {
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_31($this$dataType) {
  $this$dataType.xo(['TypeDefinition']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseTypeModel$lambda$lambda$lambda_32($this$dataType) {
  $this$dataType.xo(['TypeDefinition']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.agl.grammar.style', tmp, AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda);
  var tmp_0 = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.api.style', tmp_0, AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda_0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda($this$namespace) {
  $this$namespace.dataType('AglStyleModelDefault', AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda);
  $this$namespace.dataType('AglStyleGrammar', AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'rules', 'List', listOf('net.akehurst.language.api.style.AglStyleRule'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_0($this$dataType) {
  $this$dataType.xo(['GrammarAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda_0($this$namespace) {
  $this$namespace.dataType('AglStyleRule', AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_1);
  $this$namespace.dataType('AglStyleSelector', AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_2);
  $this$namespace.enumType('AglStyleSelectorKind', listOf_0(['LITERAL', 'PATTERN', 'RULE_NAME']));
  $this$namespace.dataType('AglStyle', AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_3);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_1($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'selector', 'AglStyleSelector');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'styles', 'Map', listOf_0(['String', 'AglStyle']));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_2($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'value', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'kind', 'AglStyleSelectorKind');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseStyleAsm$lambda$lambda$lambda_3($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'value', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseScopesAsm$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.agl.grammar.scopes', tmp, AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda($this$namespace) {
  $this$namespace.dataType('AglScopesGrammar', AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda);
  $this$namespace.dataType('ScopeModelAgl', AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_0);
  $this$namespace.dataType('ScopeDefinition', AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_1);
  $this$namespace.dataType('Identifiable', AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_2);
  $this$namespace.dataType('ReferenceDefinition', AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_3);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda($this$dataType) {
  $this$dataType.xo(['GrammarAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_0($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'scopes', 'Map', listOf_0(['String', 'ScopeDefinition']));
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'references', 'List', listOf('ReferenceDefinition'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_1($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'scopeFor', 'String');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'identifiables', 'List', listOf('Identifiable'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_2($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'typeName', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'propertyName', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseScopesAsm$lambda$lambda$lambda_3($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'inTypeName', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'referringPropertyName', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'refersToTypeName', 'List', listOf('String'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.api.automaton', tmp, AglWorkerSerialisation$initialiseMessages$lambda$lambda);
  var tmp_0 = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.editor.common.messages', tmp_0, AglWorkerSerialisation$initialiseMessages$lambda$lambda_0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda($this$namespace) {
  $this$namespace.enumType('ParseAction', emptyList());
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda_0($this$namespace) {
  $this$namespace.enumType('MessageStatus', emptyList());
  $this$namespace.dataType('MessageProcessorCreate', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda);
  $this$namespace.dataType('MessageProcessorCreateResponse', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_0);
  $this$namespace.dataType('MessageSyntaxAnalyserConfigure', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_1);
  $this$namespace.dataType('MessageSyntaxAnalyserConfigureResponse', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_2);
  $this$namespace.dataType('MessageProcessRequest', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_3);
  $this$namespace.dataType('MessageParseResult', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_4);
  $this$namespace.dataType('MessageSyntaxAnalysisResult', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_5);
  $this$namespace.dataType('MessageSemanticAnalysisResult', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_6);
  $this$namespace.dataType('MessageParserInterruptRequest', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_7);
  $this$namespace.dataType('MessageLineTokens', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_8);
  $this$namespace.dataType('MessageSetStyle', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_9);
  $this$namespace.dataType('MessageSetStyleResult', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_10);
  $this$namespace.dataType('MessageCodeCompleteRequest', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_11);
  $this$namespace.dataType('MessageCodeCompleteResult', AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_12);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'grammarStr', 'String', emptyList(), true);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'scopeModelStr', 'String', emptyList(), true);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_0($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'issues', 'List', listOf('LanguageIssue'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_1($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'configuration', 'Map', listOf_0(['String', 'Any']));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_2($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'issues', 'List', listOf('LanguageIssue'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_3($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'goalRuleName', 'String', emptyList(), true);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'text', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'context', 'Any', emptyList(), true);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_4($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'issues', 'List', listOf('LanguageIssue'));
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'treeSerialised', 'String', emptyList(), true);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_5($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'issues', 'List', listOf('LanguageIssue'));
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'asm', 'Any', emptyList(), true);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_6($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'issues', 'List', listOf('LanguageIssue'));
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'asm', 'Any', emptyList(), true);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_7($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'reason', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_8($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'lineTokens', 'Array', listOf_0(['Array', 'AglToken']));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_9($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'css', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_10($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_11($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'goalRuleName', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'text', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'position', 'Int');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseMessages$lambda$lambda$lambda_12($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'languageId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'editorId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'sessionId', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'status', 'MessageStatus');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'message', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'completionItems', 'Array', listOf('CompletionItem'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.agl.syntaxAnalyser', tmp, AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda);
  var tmp_0 = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.api.asm', tmp_0, AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda_0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda($this$namespace) {
  $this$namespace.dataType('ScopeSimple', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda);
  $this$namespace.dataType('ContextSimple', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_0);
  $this$namespace.dataType('ContextFromTypeModel', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_1);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda($this$dataType) {
  $this$dataType.wo(['AsmElementIdType']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'parent', 'ScopeSimple', listOf('AsmElementIdType'));
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'forReferenceInParent', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'forTypeName', 'String');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'scopeMap', 'Map', listOf_0(['String', 'ScopeSimple']));
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'childScopes', 'Map', listOf_0(['AsmElementIdType', 'ScopeSimple']));
  var tmp = setOf([$this$dataType.dp_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'items', 'Map', VOID, VOID, AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda$lambda($this$propertyOf) {
  $this$propertyOf.typeArgument('String');
  $this$propertyOf.typeArgument('Map', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda$lambda$lambda($this$typeArgument) {
  $this$typeArgument.typeArgument('String');
  $this$typeArgument.typeArgument('AsmElementIdType');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_0($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'rootScope', 'ScopeSimple', listOf('E'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_1($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'rootScope', 'ScopeSimple', listOf('String'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda_0($this$namespace) {
  $this$namespace.dataType('AsmElementPath', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_2);
  $this$namespace.dataType('AsmSimple', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_3);
  $this$namespace.dataType('AsmElementSimple', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_4);
  $this$namespace.dataType('AsmElementProperty', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_5);
  $this$namespace.dataType('AsmElementReference', AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_6);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_2($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'value', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_3($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'rootElements', 'List', listOf('AsmElementSimple'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_4($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'asmPath', 'AsmElementPath');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'typeName', 'String');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'properties', 'Map', listOf_0(['String', 'AsmElementProperty']));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_5($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'childIndex', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'value', 'Any');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isReference', 'Boolean');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseAsmSimple$lambda$lambda$lambda_6($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'reference', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'value', 'AsmElementSimple');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.api.grammar', tmp, AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda);
  var tmp_0 = mutableListOf(['kotlin', 'kotlin.collections', 'net.akehurst.language.agl.syntaxAnalyser']);
  $this$typeModel.namespace('net.akehurst.language.agl.grammar.grammar', tmp_0, AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda_0);
  var tmp_1 = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.agl.grammar.format', tmp_1, AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda_1);
  var tmp_2 = mutableListOf(['kotlin', 'kotlin.collections', 'net.akehurst.language.api.grammar']);
  $this$typeModel.namespace('net.akehurst.language.agl.grammar.grammar.asm', tmp_2, AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda_2);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda($this$namespace) {
  $this$namespace.dataType('Grammar', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda);
  $this$namespace.dataType('RuleItem', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_0);
  var tmp$ret$0;
  // Inline function 'kotlin.collections.listOf' call
  tmp$ret$0 = emptyList();
  $this$namespace.enumType('OverrideKind', tmp$ret$0);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda($this$dataType) {
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_0($this$dataType) {
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda_0($this$namespace) {
  $this$namespace.dataType('AglGrammarGrammar', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_1);
  $this$namespace.dataType('ContextFromGrammar', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_2);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_1($this$dataType) {
  $this$dataType.xo(['GrammarAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_2($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'rootScope', 'ScopeSimple', listOf('String'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda_1($this$namespace) {
  $this$namespace.dataType('AglFormatGrammar', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_3);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_3($this$dataType) {
  $this$dataType.xo(['GrammarAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda_2($this$namespace) {
  $this$namespace.dataType('NamespaceDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_4);
  $this$namespace.dataType('GrammarReferenceDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_5);
  $this$namespace.dataType('GrammarDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_6);
  $this$namespace.dataType('GrammarOptionDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_7);
  $this$namespace.dataType('GrammarAbstract', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_8);
  $this$namespace.dataType('GrammarRuleAbstract');
  $this$namespace.dataType('NormalRuleDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_9);
  $this$namespace.dataType('OverrideRuleDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_10);
  $this$namespace.dataType('RuleItemAbstract', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_11);
  $this$namespace.dataType('EmptyRuleDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_12);
  $this$namespace.dataType('ChoiceAbstract', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_13);
  $this$namespace.dataType('ChoiceLongestDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_14);
  $this$namespace.dataType('ChoicePriorityDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_15);
  $this$namespace.dataType('ChoiceAmbiguousDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_16);
  $this$namespace.dataType('ConcatenationDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_17);
  $this$namespace.dataType('ConcatenationItemAbstract', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_18);
  $this$namespace.dataType('SimpleItemAbstract', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_19);
  $this$namespace.dataType('GroupDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_20);
  $this$namespace.dataType('NonTerminalDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_21);
  $this$namespace.dataType('TerminalDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_22);
  $this$namespace.dataType('EmbeddedDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_23);
  $this$namespace.dataType('SeparatedListDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_24);
  $this$namespace.dataType('SimpleListDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_25);
  $this$namespace.dataType('OptionalItemDefault', AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_26);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_4($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'qualifiedName', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_5($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'localNamespace', 'NamespaceDefault');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'nameOrQName', ' String');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.bp_1]), 'resolved', 'GrammarAbstract');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_6($this$dataType) {
  $this$dataType.xo(['GrammarAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'namespace', 'NamespaceDefault');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  var tmp = setOf([$this$dataType.ep_1, $this$dataType.ap_1]);
  $this$dataType.gp(tmp, 'options', 'List', VOID, VOID, AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda$lambda($this$propertyOf) {
  $this$propertyOf.typeArgument('GrammarOptionDefault');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_7($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'value', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_8($this$dataType) {
  $this$dataType.xo(['net.akehurst.language.api.grammar.Grammar']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'namespace', 'NamespaceDefault');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'extends', 'List', listOf('GrammarReferenceDefault'));
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'grammarRule', 'List', listOf('GrammarRuleAbstract'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_9($this$dataType) {
  $this$dataType.xo(['GrammarRuleAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'grammar', 'GrammarDefault');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isSkip', 'Boolean');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isLeaf', 'Boolean');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'rhs', 'RuleItemAbstract');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_10($this$dataType) {
  $this$dataType.xo(['GrammarRuleAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.bp_1]), 'grammar', 'GrammarDefault');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isSkip', 'Boolean');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isLeaf', 'Boolean');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'overrideKind', 'OverrideKind');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'overridenRhs', 'RuleItemAbstract');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_11($this$dataType) {
  $this$dataType.xo(['net.akehurst.language.api.grammar.RuleItem']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_12($this$dataType) {
  $this$dataType.xo(['RuleItemAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_13($this$dataType) {
  $this$dataType.xo(['RuleItemAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_14($this$dataType) {
  $this$dataType.xo(['ChoiceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'alternative', 'List', listOf('net.akehurst.language.api.grammar.RuleItem'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_15($this$dataType) {
  $this$dataType.xo(['ChoiceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'alternative', 'List', listOf('net.akehurst.language.api.grammar.RuleItem'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_16($this$dataType) {
  $this$dataType.xo(['ChoiceAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'alternative', 'List', listOf('net.akehurst.language.api.grammar.RuleItem'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_17($this$dataType) {
  $this$dataType.xo(['RuleItemAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'items', 'List', listOf('net.akehurst.language.api.grammar.RuleItem'));
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_18($this$dataType) {
  $this$dataType.xo(['RuleItemAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_19($this$dataType) {
  $this$dataType.xo(['ConcatenationItemAbstract']);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_20($this$dataType) {
  $this$dataType.xo(['ConcatenationItemAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'groupedContent', 'net.akehurst.language.api.grammar.RuleItem');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_21($this$dataType) {
  $this$dataType.xo(['RuleItemAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'name', 'String');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_22($this$dataType) {
  $this$dataType.xo(['RuleItemAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'value', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'isPattern', 'Boolean');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_23($this$dataType) {
  $this$dataType.xo(['RuleItemAbstract']);
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'embeddedGoalName', 'String');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'embeddedGrammarReference', 'GrammarReferenceDefault');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_24($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'min', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'max', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'item', 'SimpleItemAbstract');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'separator', 'SimpleItem');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_25($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'min', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'max', 'Int');
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'item', 'SimpleItemAbstract');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseGrammarAsm$lambda$lambda$lambda_26($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'item', 'net.akehurst.language.api.grammar.RuleItem');
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseSPPT$lambda($this$typeModel) {
  var tmp = mutableListOf(['kotlin', 'kotlin.collections']);
  $this$typeModel.namespace('net.akehurst.language.agl.sppt', tmp, AglWorkerSerialisation$initialiseSPPT$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseSPPT$lambda$lambda($this$namespace) {
  $this$namespace.dataType('TreeDataComplete', AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda($this$dataType) {
  $this$dataType.gp(setOf([$this$dataType.ep_1, $this$dataType.ap_1]), 'forStateSetNumber', 'Int');
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'root', 'CN', emptyList(), true);
  $this$dataType.gp(setOf([$this$dataType.dp_1, $this$dataType.ap_1]), 'initialSkip', 'TreeDataComplete', listOf('CN'), true);
  var tmp = setOf([$this$dataType.dp_1, $this$dataType.ap_1]);
  var tmp_0 = emptyList();
  $this$dataType.fp(tmp, 'completeChildren', 'Map', tmp_0, false, AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda$lambda($this$propertyOf) {
  $this$propertyOf.typeArgument('CN');
  $this$propertyOf.typeArgument('Map', AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda$lambda$lambda($this$typeArgument) {
  $this$typeArgument.typeArgument('Int');
  $this$typeArgument.typeArgument('List', AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglWorkerSerialisation$initialiseSPPT$lambda$lambda$lambda$lambda$lambda$lambda($this$typeArgument) {
  $this$typeArgument.typeArgument('CN');
  return Unit_getInstance();
}
var AglWorkerSerialisation_instance;
function AglWorkerSerialisation_getInstance() {
  if (AglWorkerSerialisation_instance === VOID)
    new AglWorkerSerialisation_0();
  return AglWorkerSerialisation_instance;
}
var MessageStatus_START_instance;
var MessageStatus_FAILURE_instance;
var MessageStatus_SUCCESS_instance;
function values_7() {
  return [MessageStatus_START_getInstance(), MessageStatus_FAILURE_getInstance(), MessageStatus_SUCCESS_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'START':
      return MessageStatus_START_getInstance();
    case 'FAILURE':
      return MessageStatus_FAILURE_getInstance();
    case 'SUCCESS':
      return MessageStatus_SUCCESS_getInstance();
    default:
      MessageStatus_initEntries();
      THROW_ISE();
      break;
  }
}
var MessageStatus_entriesInitialized;
function MessageStatus_initEntries() {
  if (MessageStatus_entriesInitialized)
    return Unit_getInstance();
  MessageStatus_entriesInitialized = true;
  MessageStatus_START_instance = new MessageStatus('START', 0);
  MessageStatus_FAILURE_instance = new MessageStatus('FAILURE', 1);
  MessageStatus_SUCCESS_instance = new MessageStatus('SUCCESS', 2);
}
function MessageStatus_START_getInstance() {
  MessageStatus_initEntries();
  return MessageStatus_START_instance;
}
function MessageStatus_FAILURE_getInstance() {
  MessageStatus_initEntries();
  return MessageStatus_FAILURE_instance;
}
function MessageStatus_SUCCESS_getInstance() {
  MessageStatus_initEntries();
  return MessageStatus_SUCCESS_instance;
}
function processorCreateResult($this, message) {
  if (message.k4o_1 === $this.editorId ? message.j4o_1 === $this.languageIdentity : false) {
    if (message.status.equals(MessageStatus_SUCCESS_getInstance())) {
      switch (message.message) {
        case 'OK':
          $this.log(LogLevel_Debug_getInstance(), 'New Processor created for ' + $this.editorId, null);
          $this.workerTokenizer.acceptingTokens = true;
          $this.processSentence();
          $this.resetTokenization();
          break;
        case 'reset':
          $this.log(LogLevel_Debug_getInstance(), 'Reset Processor for ' + $this.editorId, null);
          break;
        default:
          $this.log(LogLevel_Error_getInstance(), 'Unknown result message from create Processor for ' + $this.editorId + ': ' + message, null);
          break;
      }
    } else {
      $this.log(LogLevel_Error_getInstance(), 'Failed to create processor ' + message.message, null);
    }
  }
}
function syntaxAnalyserConfigureResult($this, message) {
  if (message.status.equals(MessageStatus_FAILURE_getInstance())) {
    $this.log(LogLevel_Error_getInstance(), 'SyntaxAnalyserConfigure failed for ' + $this.languageIdentity + ': ' + message.message, null);
  }
  $this.createIssueMarkers(toList(message.issues));
}
function lineTokens($this, event) {
  if (event.status.equals(MessageStatus_SUCCESS_getInstance())) {
    $this.log(LogLevel_Debug_getInstance(), 'Debug: new line tokens from successful parse of ' + $this.editorId, null);
    $this.workerTokenizer.receiveTokens(event.lineTokens);
    $this.resetTokenization();
  } else {
    $this.log(LogLevel_Error_getInstance(), 'LineTokens - ' + event.message, null);
  }
}
function parseResult($this, event) {
  switch (event.status.bc_1) {
    case 0:
      $this.notifyParse(new ParseEvent(EventStatus_START_getInstance(), 'Start', null, emptyList()));
      break;
    case 1:
      $this.log(LogLevel_Debug_getInstance(), 'Cannot parse text in ' + $this.editorId + ' for language ' + $this.languageIdentity + ': ' + event.message, null);
      $this.workerTokenizer.reset();
      $this.resetTokenization();
      $this.clearErrorMarkers();
      $this.createIssueMarkers(toList(event.issues));
      $this.notifyParse(new ParseEvent(EventStatus_FAILURE_getInstance(), event.message, null, toList(event.issues)));
      break;
    case 2:
      $this.resetTokenization();
      $this.clearErrorMarkers();
      $this.createIssueMarkers(toList(event.issues));
      var treeStr = event.treeSerialised;
      var tmp;
      if (treeStr == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'net.akehurst.language.editor.common.AglEditorJsAbstract.parseResult.<anonymous>' call
        var unescaped = Companion_getInstance().g4f(treeStr);
        tmp = JSON.parse(unescaped);
      }

      var treeJS = tmp;
      $this.notifyParse(new ParseEvent(EventStatus_SUCCESS_getInstance(), 'Success', treeJS, toList(event.issues)));
      break;
  }
}
function syntaxAnalysisResult($this, event) {
  switch (event.status.bc_1) {
    case 0:
      $this.notifySyntaxAnalysis(new SyntaxAnalysisEvent(EventStatus_START_getInstance(), 'Start', null, emptyList()));
      break;
    case 1:
      $this.clearErrorMarkers();
      $this.createIssueMarkers(toList(event.issues));
      $this.notifySyntaxAnalysis(new SyntaxAnalysisEvent(EventStatus_FAILURE_getInstance(), event.message, event.asm, toList(event.issues)));
      break;
    case 2:
      $this.clearErrorMarkers();
      $this.createIssueMarkers(toList(event.issues));
      $this.notifySyntaxAnalysis(new SyntaxAnalysisEvent(EventStatus_SUCCESS_getInstance(), 'Success', event.asm, toList(event.issues)));
      break;
  }
}
function semanticAnalysisResult($this, event) {
  switch (event.status.bc_1) {
    case 0:
      $this.notifySemanticAnalysis(new SemanticAnalysisEvent(EventStatus_START_getInstance(), 'Start', null, emptyList()));
      break;
    case 1:
      $this.clearErrorMarkers();
      $this.createIssueMarkers(toList(event.issues));
      $this.notifySemanticAnalysis(new SemanticAnalysisEvent(EventStatus_FAILURE_getInstance(), event.message, event.asm, toList(event.issues)));
      break;
    case 2:
      $this.clearErrorMarkers();
      $this.createIssueMarkers(toList(event.issues));
      $this.notifySemanticAnalysis(new SemanticAnalysisEvent(EventStatus_SUCCESS_getInstance(), 'Success', event.asm, toList(event.issues)));
      break;
  }
}
function AglEditorJsAbstract$connectWorker$lambda(this$0) {
  return function (message) {
    var tmp;
    if (message.status.equals(MessageStatus_SUCCESS_getInstance())) {
      this$0.resetTokenization();
      tmp = Unit_getInstance();
    } else {
      this$0.log(LogLevel_Error_getInstance(), message.message, null);
      tmp = Unit_getInstance();
    }
    return Unit_getInstance();
  };
}
function AglEditorJsAbstract$processorCreateResult$ref($boundThis) {
  var l = function (p0) {
    processorCreateResult($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'processorCreateResult';
  return l;
}
function AglEditorJsAbstract$syntaxAnalyserConfigureResult$ref($boundThis) {
  var l = function (p0) {
    syntaxAnalyserConfigureResult($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'syntaxAnalyserConfigureResult';
  return l;
}
function AglEditorJsAbstract$parseResult$ref($boundThis) {
  var l = function (p0) {
    parseResult($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'parseResult';
  return l;
}
function AglEditorJsAbstract$lineTokens$ref($boundThis) {
  var l = function (p0) {
    lineTokens($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'lineTokens';
  return l;
}
function AglEditorJsAbstract$syntaxAnalysisResult$ref($boundThis) {
  var l = function (p0) {
    syntaxAnalysisResult($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'syntaxAnalysisResult';
  return l;
}
function AglEditorJsAbstract$semanticAnalysisResult$ref($boundThis) {
  var l = function (p0) {
    semanticAnalysisResult($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'semanticAnalysisResult';
  return l;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function receiveMessageFromWorker($this, msg) {
  $this.agl.logger.log(LogLevel_Trace_getInstance(), 'Received message: ' + msg, null);
  if ($this.agl.languageIdentity === msg.languageId ? $this.agl.editorId === msg.editorId : false) {
    if (msg instanceof MessageSetStyleResult)
      $this.setStyleResult(msg);
    else {
      if (msg instanceof MessageProcessorCreateResponse)
        $this.processorCreateResult(msg);
      else {
        if (msg instanceof MessageSyntaxAnalyserConfigureResponse)
          $this.syntaxAnalyserConfigureResult(msg);
        else {
          if (msg instanceof MessageParseResult)
            $this.parseResult(msg);
          else {
            if (msg instanceof MessageLineTokens)
              $this.lineTokens(msg);
            else {
              if (msg instanceof MessageSyntaxAnalysisResult)
                $this.syntaxAnalysisResult(msg);
              else {
                if (msg instanceof MessageSemanticAnalysisResult)
                  $this.semanticAnalysisResult(msg);
                else {
                  if (msg instanceof MessageCodeCompleteResult)
                    $this.codeCompleteResult(msg);
                  else {
                    throw IllegalStateException.y1('Unknown Message type');
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function AglWorkerClient$setStyleResult$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$processorCreateResult$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$syntaxAnalyserConfigureResult$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$parseResult$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$lineTokens$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$syntaxAnalysisResult$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$semanticAnalysisResult$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$codeCompleteResult$lambda(_anonymous_parameter_0__qggqh8) {
  return Unit_getInstance();
}
function AglWorkerClient$initialise$lambda(this$0) {
  return function (it) {
    return this$0.agl.logger.log(LogLevel_Error_getInstance(), toString(it), null);
  };
}
function AglWorkerClient$initialise$lambda_0(this$0) {
  return function (ev) {
    var tmp;
    try {
      var data = (ev instanceof MessageEvent ? ev : THROW_CCE()).data;
      var tmp_0;
      if (!(data == null) ? typeof data === 'string' : false) {
        var tmp_1 = (ev instanceof MessageEvent ? ev : THROW_CCE()).data;
        var str = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE();
        var tmp_2;
        if (startsWith(str, 'Error:')) {
          this$0.agl.logger.log(LogLevel_Error_getInstance(), substringAfter(str, 'Error:'), null);
          tmp_2 = Unit_getInstance();
        } else {
          var msg = AglWorkerSerialisation_getInstance().deserialise(str);
          var tmp_3;
          if (null == msg) {
            this$0.agl.logger.log(LogLevel_Error_getInstance(), 'Message from Worker not handled: ' + str, null);
            tmp_3 = Unit_getInstance();
          } else {
            receiveMessageFromWorker(this$0, msg);
            tmp_3 = Unit_getInstance();
          }
          tmp_2 = tmp_3;
        }
        tmp_0 = tmp_2;
      } else {
        this$0.agl.logger.log(LogLevel_Error_getInstance(), "Handling message from Worker, data content should be a String, got - '" + toString_0(ev.data) + "'", null);
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var e = $p;
        this$0.agl.logger.log(LogLevel_Error_getInstance(), 'Handling message from Worker', e);
        tmp_4 = Unit_getInstance();
      } else {
        throw $p;
      }
      tmp = tmp_4;
    }
    return Unit_getInstance();
  };
}
//region block: post-declaration
setMetadataFor(BuildConfig_0, 'BuildConfig', objectMeta);
setMetadataFor(KotlinxReflectForModule_0, 'KotlinxReflectForModule', objectMeta);
setMetadataFor(AglComponents, 'AglComponents', classMeta);
setMetadataFor(AglEditorAbstract, 'AglEditorAbstract', classMeta, VOID, [AglEditor]);
setMetadataFor(AglLoggerToConsole, 'AglLoggerToConsole', classMeta);
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(AglStyleHandler, 'AglStyleHandler', classMeta);
setMetadataFor(AglTokenizerByWorker, 'AglTokenizerByWorker', interfaceMeta);
setMetadataFor(AglLineState, 'AglLineState', classMeta);
setMetadataFor(AglToken, 'AglToken', classMeta);
setMetadataFor(AglTokenizer, 'AglTokenizer', classMeta);
setMetadataFor(AglWorkerSerialisation_0, 'AglWorkerSerialisation', objectMeta);
setMetadataFor(MessageStatus, 'MessageStatus', classMeta);
setMetadataFor(AglWorkerMessage, 'AglWorkerMessage', classMeta);
setMetadataFor(MessageProcessorCreate, 'MessageProcessorCreate', classMeta);
setMetadataFor(MessageProcessorCreateResponse, 'MessageProcessorCreateResponse', classMeta);
setMetadataFor(MessageProcessorDelete, 'MessageProcessorDelete', classMeta);
setMetadataFor(MessageProcessorDeleteResponse, 'MessageProcessorDeleteResponse', classMeta);
setMetadataFor(MessageSyntaxAnalyserConfigure, 'MessageSyntaxAnalyserConfigure', classMeta);
setMetadataFor(MessageSyntaxAnalyserConfigureResponse, 'MessageSyntaxAnalyserConfigureResponse', classMeta);
setMetadataFor(MessageProcessRequest, 'MessageProcessRequest', classMeta);
setMetadataFor(MessageParseResult, 'MessageParseResult', classMeta);
setMetadataFor(MessageSyntaxAnalysisResult, 'MessageSyntaxAnalysisResult', classMeta);
setMetadataFor(MessageSemanticAnalysisResult, 'MessageSemanticAnalysisResult', classMeta);
setMetadataFor(MessageParserInterruptRequest, 'MessageParserInterruptRequest', classMeta);
setMetadataFor(MessageLineTokens, 'MessageLineTokens', classMeta);
setMetadataFor(MessageSetStyle, 'MessageSetStyle', classMeta);
setMetadataFor(MessageSetStyleResult, 'MessageSetStyleResult', classMeta);
setMetadataFor(MessageCodeCompleteRequest, 'MessageCodeCompleteRequest', classMeta);
setMetadataFor(MessageCodeCompleteResult, 'MessageCodeCompleteResult', classMeta);
setMetadataFor(MessageGrammarAmbiguityAnalysisRequest, 'MessageGrammarAmbiguityAnalysisRequest', classMeta);
setMetadataFor(MessageGrammarAmbiguityAnalysisResult, 'MessageGrammarAmbiguityAnalysisResult', classMeta);
setMetadataFor(AglEditorJsAbstract, 'AglEditorJsAbstract', classMeta);
setMetadataFor(Companion_0, 'Companion', objectMeta);
setMetadataFor(AglWorkerClient, 'AglWorkerClient', classMeta);
//endregion
//region block: exports
var BuildConfig = {getInstance: BuildConfig_getInstance};
var KotlinxReflectForModule = {getInstance: KotlinxReflectForModule_getInstance};
var AglWorkerSerialisation = {getInstance: AglWorkerSerialisation_getInstance};
MessageStatus.values = values_7;
MessageStatus.valueOf = valueOf;
export {
  BuildConfig,
  KotlinxReflectForModule,
  AglComponents,
  AglEditorAbstract,
  AglLoggerToConsole,
  AglStyleHandler,
  AglLineState,
  AglToken,
  AglTokenizer,
  AglWorkerSerialisation,
  MessageStatus,
  AglWorkerMessage,
  MessageProcessorCreate,
  MessageProcessorCreateResponse,
  MessageProcessorDelete,
  MessageProcessorDeleteResponse,
  MessageSyntaxAnalyserConfigure,
  MessageSyntaxAnalyserConfigureResponse,
  MessageProcessRequest,
  MessageParseResult,
  MessageSyntaxAnalysisResult,
  MessageSemanticAnalysisResult,
  MessageParserInterruptRequest,
  MessageLineTokens,
  MessageSetStyle,
  MessageSetStyleResult,
  MessageCodeCompleteRequest,
  MessageCodeCompleteResult,
  MessageGrammarAmbiguityAnalysisRequest,
  MessageGrammarAmbiguityAnalysisResult,
  AglEditorJsAbstract,
  AglWorkerClient,
};
export {
  MessageStatus_FAILURE_getInstance as a,
  MessageStatus_START_getInstance as b,
  MessageStatus_SUCCESS_getInstance as c,
  Companion_getInstance_0 as d,
  AglWorkerSerialisation_getInstance as e,
  MessageCodeCompleteRequest as f,
  MessageCodeCompleteResult as g,
  MessageLineTokens as h,
  MessageParseResult as i,
  MessageParserInterruptRequest as j,
  MessageProcessRequest as k,
  MessageProcessorCreateResponse as l,
  MessageProcessorCreate as m,
  MessageProcessorDeleteResponse as n,
  MessageSemanticAnalysisResult as o,
  MessageSetStyleResult as p,
  MessageSetStyle as q,
  MessageSyntaxAnalyserConfigureResponse as r,
  MessageSyntaxAnalyserConfigure as s,
  MessageSyntaxAnalysisResult as t,
  AglEditorJsAbstract as u,
  AglLineState as v,
  AglStyleHandler as w,
  AglTokenizerByWorker as x,
  AglTokenizer as y,
};
//endregion

//# sourceMappingURL=net.akehurst.language.editor-agl-editor-common.mjs.map
